var _g, _g2, _g3, _g4, _g5, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 198,
    viewBox: "0 0 267 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_31722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 33.6512C46.2464 33.8529 46.0829 34.0164 45.8811 34.0164C45.6794 34.0164 45.5159 33.8529 45.5159 33.6512C45.5159 33.4494 45.6794 33.2859 45.8811 33.2859C46.0829 33.2859 46.2464 33.4494 46.2464 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 33.6512C55.7432 33.8529 55.5797 34.0164 55.378 34.0164C55.1763 34.0164 55.0127 33.8529 55.0127 33.6512C55.0127 33.4494 55.1763 33.2859 55.378 33.2859C55.5797 33.2859 55.7432 33.4494 55.7432 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 33.6512C65.2403 33.8529 65.0767 34.0164 64.875 34.0164C64.6733 34.0164 64.5098 33.8529 64.5098 33.6512C64.5098 33.4494 64.6733 33.2859 64.875 33.2859C65.0767 33.2859 65.2403 33.4494 65.2403 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 33.6512C74.7371 33.8529 74.5736 34.0164 74.3719 34.0164C74.1702 34.0164 74.0066 33.8529 74.0066 33.6512C74.0066 33.4494 74.1702 33.2859 74.3719 33.2859C74.5736 33.2859 74.7371 33.4494 74.7371 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 33.6512C84.2339 33.8529 84.0704 34.0164 83.8687 34.0164C83.667 34.0164 83.5034 33.8529 83.5034 33.6512C83.5034 33.4494 83.667 33.2859 83.8687 33.2859C84.0704 33.2859 84.2339 33.4494 84.2339 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 33.6512C93.7308 33.8529 93.5672 34.0164 93.3655 34.0164C93.1638 34.0164 93.0002 33.8529 93.0002 33.6512C93.0002 33.4494 93.1638 33.2859 93.3655 33.2859C93.5672 33.2859 93.7308 33.4494 93.7308 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 33.6512C103.228 33.8529 103.064 34.0164 102.862 34.0164C102.661 34.0164 102.497 33.8529 102.497 33.6512C102.497 33.4494 102.661 33.2859 102.862 33.2859C103.064 33.2859 103.228 33.4494 103.228 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 33.6512C112.725 33.8529 112.561 34.0164 112.359 34.0164C112.158 34.0164 111.994 33.8529 111.994 33.6512C111.994 33.4494 112.158 33.2859 112.359 33.2859C112.561 33.2859 112.725 33.4494 112.725 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 33.6512C122.221 33.8529 122.058 34.0164 121.856 34.0164C121.655 34.0164 121.491 33.8529 121.491 33.6512C121.491 33.4494 121.655 33.2859 121.856 33.2859C122.058 33.2859 122.221 33.4494 122.221 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 33.6512C131.718 33.8529 131.555 34.0164 131.353 34.0164C131.151 34.0164 130.988 33.8529 130.988 33.6512C130.988 33.4494 131.151 33.2859 131.353 33.2859C131.555 33.2859 131.718 33.4494 131.718 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 43.1475C46.2464 43.3492 46.0829 43.5128 45.8811 43.5128C45.6794 43.5128 45.5159 43.3492 45.5159 43.1475C45.5159 42.9458 45.6794 42.7822 45.8811 42.7822C46.0829 42.7822 46.2464 42.9458 46.2464 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 43.1475C55.7432 43.3492 55.5797 43.5128 55.378 43.5128C55.1763 43.5128 55.0127 43.3492 55.0127 43.1475C55.0127 42.9458 55.1763 42.7822 55.378 42.7822C55.5797 42.7822 55.7432 42.9458 55.7432 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 43.1475C65.2403 43.3492 65.0767 43.5128 64.875 43.5128C64.6733 43.5128 64.5098 43.3492 64.5098 43.1475C64.5098 42.9458 64.6733 42.7822 64.875 42.7822C65.0767 42.7822 65.2403 42.9458 65.2403 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 43.1475C74.7371 43.3492 74.5736 43.5128 74.3719 43.5128C74.1702 43.5128 74.0066 43.3492 74.0066 43.1475C74.0066 42.9458 74.1702 42.7822 74.3719 42.7822C74.5736 42.7822 74.7371 42.9458 74.7371 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 43.1475C84.2339 43.3492 84.0704 43.5128 83.8687 43.5128C83.667 43.5128 83.5034 43.3492 83.5034 43.1475C83.5034 42.9458 83.667 42.7822 83.8687 42.7822C84.0704 42.7822 84.2339 42.9458 84.2339 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 43.1475C93.7308 43.3492 93.5672 43.5128 93.3655 43.5128C93.1638 43.5128 93.0002 43.3492 93.0002 43.1475C93.0002 42.9458 93.1638 42.7822 93.3655 42.7822C93.5672 42.7822 93.7308 42.9458 93.7308 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 43.1475C103.228 43.3492 103.064 43.5128 102.862 43.5128C102.661 43.5128 102.497 43.3492 102.497 43.1475C102.497 42.9458 102.661 42.7822 102.862 42.7822C103.064 42.7822 103.228 42.9458 103.228 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 43.1475C112.725 43.3492 112.561 43.5128 112.359 43.5128C112.158 43.5128 111.994 43.3492 111.994 43.1475C111.994 42.9458 112.158 42.7822 112.359 42.7822C112.561 42.7822 112.725 42.9458 112.725 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 43.1475C122.221 43.3492 122.058 43.5128 121.856 43.5128C121.655 43.5128 121.491 43.3492 121.491 43.1475C121.491 42.9458 121.655 42.7822 121.856 42.7822C122.058 42.7822 122.221 42.9458 122.221 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 43.1475C131.718 43.3492 131.555 43.5128 131.353 43.5128C131.151 43.5128 130.988 43.3492 130.988 43.1475C130.988 42.9458 131.151 42.7822 131.353 42.7822C131.555 42.7822 131.718 42.9458 131.718 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 52.6441C46.2464 52.8458 46.0829 53.0093 45.8811 53.0093C45.6794 53.0093 45.5159 52.8458 45.5159 52.6441C45.5159 52.4424 45.6794 52.2788 45.8811 52.2788C46.0829 52.2788 46.2464 52.4424 46.2464 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 52.6441C55.7432 52.8458 55.5797 53.0093 55.378 53.0093C55.1763 53.0093 55.0127 52.8458 55.0127 52.6441C55.0127 52.4424 55.1763 52.2788 55.378 52.2788C55.5797 52.2788 55.7432 52.4424 55.7432 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 52.6441C65.2403 52.8458 65.0767 53.0093 64.875 53.0093C64.6733 53.0093 64.5098 52.8458 64.5098 52.6441C64.5098 52.4424 64.6733 52.2788 64.875 52.2788C65.0767 52.2788 65.2403 52.4424 65.2403 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 52.6441C74.7371 52.8458 74.5736 53.0093 74.3719 53.0093C74.1702 53.0093 74.0066 52.8458 74.0066 52.6441C74.0066 52.4424 74.1702 52.2788 74.3719 52.2788C74.5736 52.2788 74.7371 52.4424 74.7371 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 52.6441C84.2339 52.8458 84.0704 53.0093 83.8687 53.0093C83.667 53.0093 83.5034 52.8458 83.5034 52.6441C83.5034 52.4424 83.667 52.2788 83.8687 52.2788C84.0704 52.2788 84.2339 52.4424 84.2339 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 52.6441C93.7308 52.8458 93.5672 53.0093 93.3655 53.0093C93.1638 53.0093 93.0002 52.8458 93.0002 52.6441C93.0002 52.4424 93.1638 52.2788 93.3655 52.2788C93.5672 52.2788 93.7308 52.4424 93.7308 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 52.6441C103.228 52.8458 103.064 53.0093 102.862 53.0093C102.661 53.0093 102.497 52.8458 102.497 52.6441C102.497 52.4424 102.661 52.2788 102.862 52.2788C103.064 52.2788 103.228 52.4424 103.228 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 52.6441C112.725 52.8458 112.561 53.0093 112.359 53.0093C112.158 53.0093 111.994 52.8458 111.994 52.6441C111.994 52.4424 112.158 52.2788 112.359 52.2788C112.561 52.2788 112.725 52.4424 112.725 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 52.6441C122.221 52.8458 122.058 53.0093 121.856 53.0093C121.655 53.0093 121.491 52.8458 121.491 52.6441C121.491 52.4424 121.655 52.2788 121.856 52.2788C122.058 52.2788 122.221 52.4424 122.221 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 52.6441C131.718 52.8458 131.555 53.0093 131.353 53.0093C131.151 53.0093 130.988 52.8458 130.988 52.6441C130.988 52.4424 131.151 52.2788 131.353 52.2788C131.555 52.2788 131.718 52.4424 131.718 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 62.1407C46.2464 62.3424 46.0829 62.5059 45.8811 62.5059C45.6794 62.5059 45.5159 62.3424 45.5159 62.1407C45.5159 61.939 45.6794 61.7754 45.8811 61.7754C46.0829 61.7754 46.2464 61.939 46.2464 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 62.1407C55.7432 62.3424 55.5797 62.5059 55.378 62.5059C55.1763 62.5059 55.0127 62.3424 55.0127 62.1407C55.0127 61.939 55.1763 61.7754 55.378 61.7754C55.5797 61.7754 55.7432 61.939 55.7432 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 62.1407C65.2403 62.3424 65.0767 62.5059 64.875 62.5059C64.6733 62.5059 64.5098 62.3424 64.5098 62.1407C64.5098 61.939 64.6733 61.7754 64.875 61.7754C65.0767 61.7754 65.2403 61.939 65.2403 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 62.1407C74.7371 62.3424 74.5736 62.5059 74.3719 62.5059C74.1702 62.5059 74.0066 62.3424 74.0066 62.1407C74.0066 61.939 74.1702 61.7754 74.3719 61.7754C74.5736 61.7754 74.7371 61.939 74.7371 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 62.1407C84.2339 62.3424 84.0704 62.5059 83.8687 62.5059C83.667 62.5059 83.5034 62.3424 83.5034 62.1407C83.5034 61.939 83.667 61.7754 83.8687 61.7754C84.0704 61.7754 84.2339 61.939 84.2339 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 62.1407C93.7308 62.3424 93.5672 62.5059 93.3655 62.5059C93.1638 62.5059 93.0002 62.3424 93.0002 62.1407C93.0002 61.939 93.1638 61.7754 93.3655 61.7754C93.5672 61.7754 93.7308 61.939 93.7308 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 62.1407C103.228 62.3424 103.064 62.5059 102.862 62.5059C102.661 62.5059 102.497 62.3424 102.497 62.1407C102.497 61.939 102.661 61.7754 102.862 61.7754C103.064 61.7754 103.228 61.939 103.228 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 62.1407C112.725 62.3424 112.561 62.5059 112.359 62.5059C112.158 62.5059 111.994 62.3424 111.994 62.1407C111.994 61.939 112.158 61.7754 112.359 61.7754C112.561 61.7754 112.725 61.939 112.725 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 62.1407C122.221 62.3424 122.058 62.5059 121.856 62.5059C121.655 62.5059 121.491 62.3424 121.491 62.1407C121.491 61.939 121.655 61.7754 121.856 61.7754C122.058 61.7754 122.221 61.939 122.221 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 62.1407C131.718 62.3424 131.555 62.5059 131.353 62.5059C131.151 62.5059 130.988 62.3424 130.988 62.1407C130.988 61.939 131.151 61.7754 131.353 61.7754C131.555 61.7754 131.718 61.939 131.718 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 71.6385C46.2464 71.8402 46.0829 72.0037 45.8811 72.0037C45.6794 72.0037 45.5159 71.8402 45.5159 71.6385C45.5159 71.4368 45.6794 71.2732 45.8811 71.2732C46.0829 71.2732 46.2464 71.4368 46.2464 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 71.6385C55.7432 71.8402 55.5797 72.0037 55.378 72.0037C55.1763 72.0037 55.0127 71.8402 55.0127 71.6385C55.0127 71.4368 55.1763 71.2732 55.378 71.2732C55.5797 71.2732 55.7432 71.4368 55.7432 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 71.6385C65.2403 71.8402 65.0767 72.0037 64.875 72.0037C64.6733 72.0037 64.5098 71.8402 64.5098 71.6385C64.5098 71.4368 64.6733 71.2732 64.875 71.2732C65.0767 71.2732 65.2403 71.4368 65.2403 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 71.6385C74.7371 71.8402 74.5736 72.0037 74.3719 72.0037C74.1702 72.0037 74.0066 71.8402 74.0066 71.6385C74.0066 71.4368 74.1702 71.2732 74.3719 71.2732C74.5736 71.2732 74.7371 71.4368 74.7371 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 71.6385C84.2339 71.8402 84.0704 72.0037 83.8687 72.0037C83.667 72.0037 83.5034 71.8402 83.5034 71.6385C83.5034 71.4368 83.667 71.2732 83.8687 71.2732C84.0704 71.2732 84.2339 71.4368 84.2339 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 71.6385C93.7308 71.8402 93.5672 72.0037 93.3655 72.0037C93.1638 72.0037 93.0002 71.8402 93.0002 71.6385C93.0002 71.4368 93.1638 71.2732 93.3655 71.2732C93.5672 71.2732 93.7308 71.4368 93.7308 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 71.6385C103.228 71.8402 103.064 72.0037 102.862 72.0037C102.661 72.0037 102.497 71.8402 102.497 71.6385C102.497 71.4368 102.661 71.2732 102.862 71.2732C103.064 71.2732 103.228 71.4368 103.228 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 71.6385C112.725 71.8402 112.561 72.0037 112.359 72.0037C112.158 72.0037 111.994 71.8402 111.994 71.6385C111.994 71.4368 112.158 71.2732 112.359 71.2732C112.561 71.2732 112.725 71.4368 112.725 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 71.6385C122.221 71.8402 122.058 72.0037 121.856 72.0037C121.655 72.0037 121.491 71.8402 121.491 71.6385C121.491 71.4368 121.655 71.2732 121.856 71.2732C122.058 71.2732 122.221 71.4368 122.221 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 71.6385C131.718 71.8402 131.555 72.0037 131.353 72.0037C131.151 72.0037 130.988 71.8402 130.988 71.6385C130.988 71.4368 131.151 71.2732 131.353 71.2732C131.555 71.2732 131.718 71.4368 131.718 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 81.1348C46.2464 81.3365 46.0829 81.5001 45.8811 81.5001C45.6794 81.5001 45.5159 81.3365 45.5159 81.1348C45.5159 80.9331 45.6794 80.7695 45.8811 80.7695C46.0829 80.7695 46.2464 80.9331 46.2464 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 81.1348C55.7432 81.3365 55.5797 81.5001 55.378 81.5001C55.1763 81.5001 55.0127 81.3365 55.0127 81.1348C55.0127 80.9331 55.1763 80.7695 55.378 80.7695C55.5797 80.7695 55.7432 80.9331 55.7432 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 81.1348C65.2403 81.3365 65.0767 81.5001 64.875 81.5001C64.6733 81.5001 64.5098 81.3365 64.5098 81.1348C64.5098 80.9331 64.6733 80.7695 64.875 80.7695C65.0767 80.7695 65.2403 80.9331 65.2403 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 81.1348C74.7371 81.3365 74.5736 81.5001 74.3719 81.5001C74.1702 81.5001 74.0066 81.3365 74.0066 81.1348C74.0066 80.9331 74.1702 80.7695 74.3719 80.7695C74.5736 80.7695 74.7371 80.9331 74.7371 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 81.1348C84.2339 81.3365 84.0704 81.5001 83.8687 81.5001C83.667 81.5001 83.5034 81.3365 83.5034 81.1348C83.5034 80.9331 83.667 80.7695 83.8687 80.7695C84.0704 80.7695 84.2339 80.9331 84.2339 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 81.1348C93.7308 81.3365 93.5672 81.5001 93.3655 81.5001C93.1638 81.5001 93.0002 81.3365 93.0002 81.1348C93.0002 80.9331 93.1638 80.7695 93.3655 80.7695C93.5672 80.7695 93.7308 80.9331 93.7308 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 81.1348C103.228 81.3365 103.064 81.5001 102.862 81.5001C102.661 81.5001 102.497 81.3365 102.497 81.1348C102.497 80.9331 102.661 80.7695 102.862 80.7695C103.064 80.7695 103.228 80.9331 103.228 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 81.1348C112.725 81.3365 112.561 81.5001 112.359 81.5001C112.158 81.5001 111.994 81.3365 111.994 81.1348C111.994 80.9331 112.158 80.7695 112.359 80.7695C112.561 80.7695 112.725 80.9331 112.725 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 81.1348C122.221 81.3365 122.058 81.5001 121.856 81.5001C121.655 81.5001 121.491 81.3365 121.491 81.1348C121.491 80.9331 121.655 80.7695 121.856 80.7695C122.058 80.7695 122.221 80.9331 122.221 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 81.1348C131.718 81.3365 131.555 81.5001 131.353 81.5001C131.151 81.5001 130.988 81.3365 130.988 81.1348C130.988 80.9331 131.151 80.7695 131.353 80.7695C131.555 80.7695 131.718 80.9331 131.718 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 90.6326C46.2464 90.8343 46.0829 90.9979 45.8811 90.9979C45.6794 90.9979 45.5159 90.8343 45.5159 90.6326C45.5159 90.4309 45.6794 90.2673 45.8811 90.2673C46.0829 90.2673 46.2464 90.4309 46.2464 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 90.6326C55.7432 90.8343 55.5797 90.9979 55.378 90.9979C55.1763 90.9979 55.0127 90.8343 55.0127 90.6326C55.0127 90.4309 55.1763 90.2673 55.378 90.2673C55.5797 90.2673 55.7432 90.4309 55.7432 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 90.6326C65.2403 90.8343 65.0767 90.9979 64.875 90.9979C64.6733 90.9979 64.5098 90.8343 64.5098 90.6326C64.5098 90.4309 64.6733 90.2673 64.875 90.2673C65.0767 90.2673 65.2403 90.4309 65.2403 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 90.6326C74.7371 90.8343 74.5736 90.9979 74.3719 90.9979C74.1702 90.9979 74.0066 90.8343 74.0066 90.6326C74.0066 90.4309 74.1702 90.2673 74.3719 90.2673C74.5736 90.2673 74.7371 90.4309 74.7371 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 90.6326C84.2339 90.8343 84.0704 90.9979 83.8687 90.9979C83.667 90.9979 83.5034 90.8343 83.5034 90.6326C83.5034 90.4309 83.667 90.2673 83.8687 90.2673C84.0704 90.2673 84.2339 90.4309 84.2339 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 90.6326C93.7308 90.8343 93.5672 90.9979 93.3655 90.9979C93.1638 90.9979 93.0002 90.8343 93.0002 90.6326C93.0002 90.4309 93.1638 90.2673 93.3655 90.2673C93.5672 90.2673 93.7308 90.4309 93.7308 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 90.6326C103.228 90.8343 103.064 90.9979 102.862 90.9979C102.661 90.9979 102.497 90.8343 102.497 90.6326C102.497 90.4309 102.661 90.2673 102.862 90.2673C103.064 90.2673 103.228 90.4309 103.228 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 90.6326C112.725 90.8343 112.561 90.9979 112.359 90.9979C112.158 90.9979 111.994 90.8343 111.994 90.6326C111.994 90.4309 112.158 90.2673 112.359 90.2673C112.561 90.2673 112.725 90.4309 112.725 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 90.6326C122.221 90.8343 122.058 90.9979 121.856 90.9979C121.655 90.9979 121.491 90.8343 121.491 90.6326C121.491 90.4309 121.655 90.2673 121.856 90.2673C122.058 90.2673 122.221 90.4309 122.221 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 90.6326C131.718 90.8343 131.555 90.9979 131.353 90.9979C131.151 90.9979 130.988 90.8343 130.988 90.6326C130.988 90.4309 131.151 90.2673 131.353 90.2673C131.555 90.2673 131.718 90.4309 131.718 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 100.129C46.2464 100.331 46.0829 100.494 45.8811 100.494C45.6794 100.494 45.5159 100.331 45.5159 100.129C45.5159 99.9275 45.6794 99.7639 45.8811 99.7639C46.0829 99.7639 46.2464 99.9275 46.2464 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 100.129C55.7432 100.331 55.5797 100.494 55.378 100.494C55.1763 100.494 55.0127 100.331 55.0127 100.129C55.0127 99.9275 55.1763 99.7639 55.378 99.7639C55.5797 99.7639 55.7432 99.9275 55.7432 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 100.129C65.2403 100.331 65.0767 100.494 64.875 100.494C64.6733 100.494 64.5098 100.331 64.5098 100.129C64.5098 99.9275 64.6733 99.7639 64.875 99.7639C65.0767 99.7639 65.2403 99.9275 65.2403 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 100.129C74.7371 100.331 74.5736 100.494 74.3719 100.494C74.1702 100.494 74.0066 100.331 74.0066 100.129C74.0066 99.9275 74.1702 99.7639 74.3719 99.7639C74.5736 99.7639 74.7371 99.9275 74.7371 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 100.129C84.2339 100.331 84.0704 100.494 83.8687 100.494C83.667 100.494 83.5034 100.331 83.5034 100.129C83.5034 99.9275 83.667 99.7639 83.8687 99.7639C84.0704 99.7639 84.2339 99.9275 84.2339 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 100.129C93.7308 100.331 93.5672 100.494 93.3655 100.494C93.1638 100.494 93.0002 100.331 93.0002 100.129C93.0002 99.9275 93.1638 99.7639 93.3655 99.7639C93.5672 99.7639 93.7308 99.9275 93.7308 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 100.129C103.228 100.331 103.064 100.494 102.862 100.494C102.661 100.494 102.497 100.331 102.497 100.129C102.497 99.9275 102.661 99.7639 102.862 99.7639C103.064 99.7639 103.228 99.9275 103.228 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 100.129C112.725 100.331 112.561 100.494 112.359 100.494C112.158 100.494 111.994 100.331 111.994 100.129C111.994 99.9275 112.158 99.7639 112.359 99.7639C112.561 99.7639 112.725 99.9275 112.725 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 100.129C122.221 100.331 122.058 100.494 121.856 100.494C121.655 100.494 121.491 100.331 121.491 100.129C121.491 99.9275 121.655 99.7639 121.856 99.7639C122.058 99.7639 122.221 99.9275 122.221 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 100.129C131.718 100.331 131.555 100.494 131.353 100.494C131.151 100.494 130.988 100.331 130.988 100.129C130.988 99.9275 131.151 99.7639 131.353 99.7639C131.555 99.7639 131.718 99.9275 131.718 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 109.626C46.2464 109.827 46.0829 109.991 45.8811 109.991C45.6794 109.991 45.5159 109.827 45.5159 109.626C45.5159 109.424 45.6794 109.26 45.8811 109.26C46.0829 109.26 46.2464 109.424 46.2464 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 109.626C55.7432 109.827 55.5797 109.991 55.378 109.991C55.1763 109.991 55.0127 109.827 55.0127 109.626C55.0127 109.424 55.1763 109.26 55.378 109.26C55.5797 109.26 55.7432 109.424 55.7432 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 109.626C65.2403 109.827 65.0767 109.991 64.875 109.991C64.6733 109.991 64.5098 109.827 64.5098 109.626C64.5098 109.424 64.6733 109.26 64.875 109.26C65.0767 109.26 65.2403 109.424 65.2403 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 109.626C74.7371 109.827 74.5736 109.991 74.3719 109.991C74.1702 109.991 74.0066 109.827 74.0066 109.626C74.0066 109.424 74.1702 109.26 74.3719 109.26C74.5736 109.26 74.7371 109.424 74.7371 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 109.626C84.2339 109.827 84.0704 109.991 83.8687 109.991C83.667 109.991 83.5034 109.827 83.5034 109.626C83.5034 109.424 83.667 109.26 83.8687 109.26C84.0704 109.26 84.2339 109.424 84.2339 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 109.626C93.7308 109.827 93.5672 109.991 93.3655 109.991C93.1638 109.991 93.0002 109.827 93.0002 109.626C93.0002 109.424 93.1638 109.26 93.3655 109.26C93.5672 109.26 93.7308 109.424 93.7308 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 109.626C103.228 109.827 103.064 109.991 102.862 109.991C102.661 109.991 102.497 109.827 102.497 109.626C102.497 109.424 102.661 109.26 102.862 109.26C103.064 109.26 103.228 109.424 103.228 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 109.626C112.725 109.827 112.561 109.991 112.359 109.991C112.158 109.991 111.994 109.827 111.994 109.626C111.994 109.424 112.158 109.26 112.359 109.26C112.561 109.26 112.725 109.424 112.725 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 109.626C122.221 109.827 122.058 109.991 121.856 109.991C121.655 109.991 121.491 109.827 121.491 109.626C121.491 109.424 121.655 109.26 121.856 109.26C122.058 109.26 122.221 109.424 122.221 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 109.626C131.718 109.827 131.555 109.991 131.353 109.991C131.151 109.991 130.988 109.827 130.988 109.626C130.988 109.424 131.151 109.26 131.353 109.26C131.555 109.26 131.718 109.424 131.718 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 119.122C46.2464 119.324 46.0829 119.487 45.8811 119.487C45.6794 119.487 45.5159 119.324 45.5159 119.122C45.5159 118.92 45.6794 118.757 45.8811 118.757C46.0829 118.757 46.2464 118.92 46.2464 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 119.122C55.7432 119.324 55.5797 119.487 55.378 119.487C55.1763 119.487 55.0127 119.324 55.0127 119.122C55.0127 118.92 55.1763 118.757 55.378 118.757C55.5797 118.757 55.7432 118.92 55.7432 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 119.122C65.2403 119.324 65.0767 119.487 64.875 119.487C64.6733 119.487 64.5098 119.324 64.5098 119.122C64.5098 118.92 64.6733 118.757 64.875 118.757C65.0767 118.757 65.2403 118.92 65.2403 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 119.122C74.7371 119.324 74.5736 119.487 74.3719 119.487C74.1702 119.487 74.0066 119.324 74.0066 119.122C74.0066 118.92 74.1702 118.757 74.3719 118.757C74.5736 118.757 74.7371 118.92 74.7371 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 119.122C84.2339 119.324 84.0704 119.487 83.8687 119.487C83.667 119.487 83.5034 119.324 83.5034 119.122C83.5034 118.92 83.667 118.757 83.8687 118.757C84.0704 118.757 84.2339 118.92 84.2339 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 119.122C93.7308 119.324 93.5672 119.487 93.3655 119.487C93.1638 119.487 93.0002 119.324 93.0002 119.122C93.0002 118.92 93.1638 118.757 93.3655 118.757C93.5672 118.757 93.7308 118.92 93.7308 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 119.122C103.228 119.324 103.064 119.487 102.862 119.487C102.661 119.487 102.497 119.324 102.497 119.122C102.497 118.92 102.661 118.757 102.862 118.757C103.064 118.757 103.228 118.92 103.228 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 119.122C112.725 119.324 112.561 119.487 112.359 119.487C112.158 119.487 111.994 119.324 111.994 119.122C111.994 118.92 112.158 118.757 112.359 118.757C112.561 118.757 112.725 118.92 112.725 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 119.122C122.221 119.324 122.058 119.487 121.856 119.487C121.655 119.487 121.491 119.324 121.491 119.122C121.491 118.92 121.655 118.757 121.856 118.757C122.058 118.757 122.221 118.92 122.221 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 119.122C131.718 119.324 131.555 119.487 131.353 119.487C131.151 119.487 130.988 119.324 130.988 119.122C130.988 118.92 131.151 118.757 131.353 118.757C131.555 118.757 131.718 118.92 131.718 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 128.62C46.2464 128.822 46.0829 128.985 45.8811 128.985C45.6794 128.985 45.5159 128.822 45.5159 128.62C45.5159 128.418 45.6794 128.255 45.8811 128.255C46.0829 128.255 46.2464 128.418 46.2464 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 128.62C55.7432 128.822 55.5797 128.985 55.378 128.985C55.1763 128.985 55.0127 128.822 55.0127 128.62C55.0127 128.418 55.1763 128.255 55.378 128.255C55.5797 128.255 55.7432 128.418 55.7432 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 128.62C65.2403 128.822 65.0767 128.985 64.875 128.985C64.6733 128.985 64.5098 128.822 64.5098 128.62C64.5098 128.418 64.6733 128.255 64.875 128.255C65.0767 128.255 65.2403 128.418 65.2403 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 128.62C74.7371 128.822 74.5736 128.985 74.3719 128.985C74.1702 128.985 74.0066 128.822 74.0066 128.62C74.0066 128.418 74.1702 128.255 74.3719 128.255C74.5736 128.255 74.7371 128.418 74.7371 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 128.62C84.2339 128.822 84.0704 128.985 83.8687 128.985C83.667 128.985 83.5034 128.822 83.5034 128.62C83.5034 128.418 83.667 128.255 83.8687 128.255C84.0704 128.255 84.2339 128.418 84.2339 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 128.62C93.7308 128.822 93.5672 128.985 93.3655 128.985C93.1638 128.985 93.0002 128.822 93.0002 128.62C93.0002 128.418 93.1638 128.255 93.3655 128.255C93.5672 128.255 93.7308 128.418 93.7308 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 128.62C103.228 128.822 103.064 128.985 102.862 128.985C102.661 128.985 102.497 128.822 102.497 128.62C102.497 128.418 102.661 128.255 102.862 128.255C103.064 128.255 103.228 128.418 103.228 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 128.62C112.725 128.822 112.561 128.985 112.359 128.985C112.158 128.985 111.994 128.822 111.994 128.62C111.994 128.418 112.158 128.255 112.359 128.255C112.561 128.255 112.725 128.418 112.725 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 128.62C122.221 128.822 122.058 128.985 121.856 128.985C121.655 128.985 121.491 128.822 121.491 128.62C121.491 128.418 121.655 128.255 121.856 128.255C122.058 128.255 122.221 128.418 122.221 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 128.62C131.718 128.822 131.555 128.985 131.353 128.985C131.151 128.985 130.988 128.822 130.988 128.62C130.988 128.418 131.151 128.255 131.353 128.255C131.555 128.255 131.718 128.418 131.718 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 138.116C46.2464 138.318 46.0829 138.482 45.8811 138.482C45.6794 138.482 45.5159 138.318 45.5159 138.116C45.5159 137.915 45.6794 137.751 45.8811 137.751C46.0829 137.751 46.2464 137.915 46.2464 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 138.116C55.7432 138.318 55.5797 138.482 55.378 138.482C55.1763 138.482 55.0127 138.318 55.0127 138.116C55.0127 137.915 55.1763 137.751 55.378 137.751C55.5797 137.751 55.7432 137.915 55.7432 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 138.116C65.2403 138.318 65.0767 138.482 64.875 138.482C64.6733 138.482 64.5098 138.318 64.5098 138.116C64.5098 137.915 64.6733 137.751 64.875 137.751C65.0767 137.751 65.2403 137.915 65.2403 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 138.116C74.7371 138.318 74.5736 138.482 74.3719 138.482C74.1702 138.482 74.0066 138.318 74.0066 138.116C74.0066 137.915 74.1702 137.751 74.3719 137.751C74.5736 137.751 74.7371 137.915 74.7371 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 138.116C84.2339 138.318 84.0704 138.482 83.8687 138.482C83.667 138.482 83.5034 138.318 83.5034 138.116C83.5034 137.915 83.667 137.751 83.8687 137.751C84.0704 137.751 84.2339 137.915 84.2339 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 138.116C93.7308 138.318 93.5672 138.482 93.3655 138.482C93.1638 138.482 93.0002 138.318 93.0002 138.116C93.0002 137.915 93.1638 137.751 93.3655 137.751C93.5672 137.751 93.7308 137.915 93.7308 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 138.116C103.228 138.318 103.064 138.482 102.862 138.482C102.661 138.482 102.497 138.318 102.497 138.116C102.497 137.915 102.661 137.751 102.862 137.751C103.064 137.751 103.228 137.915 103.228 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 138.116C112.725 138.318 112.561 138.482 112.359 138.482C112.158 138.482 111.994 138.318 111.994 138.116C111.994 137.915 112.158 137.751 112.359 137.751C112.561 137.751 112.725 137.915 112.725 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 138.116C122.221 138.318 122.058 138.482 121.856 138.482C121.655 138.482 121.491 138.318 121.491 138.116C121.491 137.915 121.655 137.751 121.856 137.751C122.058 137.751 122.221 137.915 122.221 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 138.116C131.718 138.318 131.555 138.482 131.353 138.482C131.151 138.482 130.988 138.318 130.988 138.116C130.988 137.915 131.151 137.751 131.353 137.751C131.555 137.751 131.718 137.915 131.718 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 147.613C46.2464 147.814 46.0829 147.978 45.8811 147.978C45.6794 147.978 45.5159 147.814 45.5159 147.613C45.5159 147.411 45.6794 147.248 45.8811 147.248C46.0829 147.248 46.2464 147.411 46.2464 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 147.613C55.7432 147.814 55.5797 147.978 55.378 147.978C55.1763 147.978 55.0127 147.814 55.0127 147.613C55.0127 147.411 55.1763 147.248 55.378 147.248C55.5797 147.248 55.7432 147.411 55.7432 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 147.613C65.2403 147.814 65.0767 147.978 64.875 147.978C64.6733 147.978 64.5098 147.814 64.5098 147.613C64.5098 147.411 64.6733 147.248 64.875 147.248C65.0767 147.248 65.2403 147.411 65.2403 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 147.613C74.7371 147.814 74.5736 147.978 74.3719 147.978C74.1702 147.978 74.0066 147.814 74.0066 147.613C74.0066 147.411 74.1702 147.248 74.3719 147.248C74.5736 147.248 74.7371 147.411 74.7371 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 147.613C84.2339 147.814 84.0704 147.978 83.8687 147.978C83.667 147.978 83.5034 147.814 83.5034 147.613C83.5034 147.411 83.667 147.248 83.8687 147.248C84.0704 147.248 84.2339 147.411 84.2339 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 147.613C93.7308 147.814 93.5672 147.978 93.3655 147.978C93.1638 147.978 93.0002 147.814 93.0002 147.613C93.0002 147.411 93.1638 147.248 93.3655 147.248C93.5672 147.248 93.7308 147.411 93.7308 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 147.613C103.228 147.814 103.064 147.978 102.862 147.978C102.661 147.978 102.497 147.814 102.497 147.613C102.497 147.411 102.661 147.248 102.862 147.248C103.064 147.248 103.228 147.411 103.228 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 147.613C112.725 147.814 112.561 147.978 112.359 147.978C112.158 147.978 111.994 147.814 111.994 147.613C111.994 147.411 112.158 147.248 112.359 147.248C112.561 147.248 112.725 147.411 112.725 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 147.613C122.221 147.814 122.058 147.978 121.856 147.978C121.655 147.978 121.491 147.814 121.491 147.613C121.491 147.411 121.655 147.248 121.856 147.248C122.058 147.248 122.221 147.411 122.221 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 147.613C131.718 147.814 131.555 147.978 131.353 147.978C131.151 147.978 130.988 147.814 130.988 147.613C130.988 147.411 131.151 147.248 131.353 147.248C131.555 147.248 131.718 147.411 131.718 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2464 157.111C46.2464 157.312 46.0829 157.476 45.8811 157.476C45.6794 157.476 45.5159 157.312 45.5159 157.111C45.5159 156.909 45.6794 156.745 45.8811 156.745C46.0829 156.745 46.2464 156.909 46.2464 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7432 157.111C55.7432 157.312 55.5797 157.476 55.378 157.476C55.1763 157.476 55.0127 157.312 55.0127 157.111C55.0127 156.909 55.1763 156.745 55.378 156.745C55.5797 156.745 55.7432 156.909 55.7432 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2403 157.111C65.2403 157.312 65.0767 157.476 64.875 157.476C64.6733 157.476 64.5098 157.312 64.5098 157.111C64.5098 156.909 64.6733 156.745 64.875 156.745C65.0767 156.745 65.2403 156.909 65.2403 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7371 157.111C74.7371 157.312 74.5736 157.476 74.3719 157.476C74.1702 157.476 74.0066 157.312 74.0066 157.111C74.0066 156.909 74.1702 156.745 74.3719 156.745C74.5736 156.745 74.7371 156.909 74.7371 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2339 157.111C84.2339 157.312 84.0704 157.476 83.8687 157.476C83.667 157.476 83.5034 157.312 83.5034 157.111C83.5034 156.909 83.667 156.745 83.8687 156.745C84.0704 156.745 84.2339 156.909 84.2339 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7308 157.111C93.7308 157.312 93.5672 157.476 93.3655 157.476C93.1638 157.476 93.0002 157.312 93.0002 157.111C93.0002 156.909 93.1638 156.745 93.3655 156.745C93.5672 156.745 93.7308 156.909 93.7308 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.228 157.111C103.228 157.312 103.064 157.476 102.862 157.476C102.661 157.476 102.497 157.312 102.497 157.111C102.497 156.909 102.661 156.745 102.862 156.745C103.064 156.745 103.228 156.909 103.228 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.725 157.111C112.725 157.312 112.561 157.476 112.359 157.476C112.158 157.476 111.994 157.312 111.994 157.111C111.994 156.909 112.158 156.745 112.359 156.745C112.561 156.745 112.725 156.909 112.725 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.221 157.111C122.221 157.312 122.058 157.476 121.856 157.476C121.655 157.476 121.491 157.312 121.491 157.111C121.491 156.909 121.655 156.745 121.856 156.745C122.058 156.745 122.221 156.909 122.221 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.718 157.111C131.718 157.312 131.555 157.476 131.353 157.476C131.151 157.476 130.988 157.312 130.988 157.111C130.988 156.909 131.151 156.745 131.353 156.745C131.555 156.745 131.718 156.909 131.718 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 33.6512C225.957 33.8529 226.12 34.0164 226.322 34.0164C226.523 34.0164 226.687 33.8529 226.687 33.6512C226.687 33.4494 226.523 33.2859 226.322 33.2859C226.12 33.2859 225.957 33.4494 225.957 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 33.6512C216.46 33.8529 216.624 34.0164 216.825 34.0164C217.027 34.0164 217.19 33.8529 217.19 33.6512C217.19 33.4494 217.027 33.2859 216.825 33.2859C216.624 33.2859 216.46 33.4494 216.46 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 33.6512C206.963 33.8529 207.127 34.0164 207.328 34.0164C207.53 34.0164 207.693 33.8529 207.693 33.6512C207.693 33.4494 207.53 33.2859 207.328 33.2859C207.127 33.2859 206.963 33.4494 206.963 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 33.6512C197.466 33.8529 197.629 34.0164 197.831 34.0164C198.033 34.0164 198.196 33.8529 198.196 33.6512C198.196 33.4494 198.033 33.2859 197.831 33.2859C197.629 33.2859 197.466 33.4494 197.466 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 33.6512C187.969 33.8529 188.133 34.0164 188.335 34.0164C188.536 34.0164 188.7 33.8529 188.7 33.6512C188.7 33.4494 188.536 33.2859 188.335 33.2859C188.133 33.2859 187.969 33.4494 187.969 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 33.6512C178.472 33.8529 178.636 34.0164 178.837 34.0164C179.039 34.0164 179.203 33.8529 179.203 33.6512C179.203 33.4494 179.039 33.2859 178.837 33.2859C178.636 33.2859 178.472 33.4494 178.472 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 33.6512C168.976 33.8529 169.139 34.0164 169.341 34.0164C169.542 34.0164 169.706 33.8529 169.706 33.6512C169.706 33.4494 169.542 33.2859 169.341 33.2859C169.139 33.2859 168.976 33.4494 168.976 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 33.6512C159.479 33.8529 159.642 34.0164 159.844 34.0164C160.045 34.0164 160.209 33.8529 160.209 33.6512C160.209 33.4494 160.045 33.2859 159.844 33.2859C159.642 33.2859 159.479 33.4494 159.479 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 33.6512C149.982 33.8529 150.145 34.0164 150.347 34.0164C150.549 34.0164 150.712 33.8529 150.712 33.6512C150.712 33.4494 150.549 33.2859 150.347 33.2859C150.145 33.2859 149.982 33.4494 149.982 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 33.6512C140.485 33.8529 140.649 34.0164 140.85 34.0164C141.052 34.0164 141.215 33.8529 141.215 33.6512C141.215 33.4494 141.052 33.2859 140.85 33.2859C140.649 33.2859 140.485 33.4494 140.485 33.6512Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 43.1475C225.957 43.3492 226.12 43.5128 226.322 43.5128C226.523 43.5128 226.687 43.3492 226.687 43.1475C226.687 42.9458 226.523 42.7822 226.322 42.7822C226.12 42.7822 225.957 42.9458 225.957 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 43.1475C216.46 43.3492 216.624 43.5128 216.825 43.5128C217.027 43.5128 217.19 43.3492 217.19 43.1475C217.19 42.9458 217.027 42.7822 216.825 42.7822C216.624 42.7822 216.46 42.9458 216.46 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 43.1475C206.963 43.3492 207.127 43.5128 207.328 43.5128C207.53 43.5128 207.693 43.3492 207.693 43.1475C207.693 42.9458 207.53 42.7822 207.328 42.7822C207.127 42.7822 206.963 42.9458 206.963 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 43.1475C197.466 43.3492 197.629 43.5128 197.831 43.5128C198.033 43.5128 198.196 43.3492 198.196 43.1475C198.196 42.9458 198.033 42.7822 197.831 42.7822C197.629 42.7822 197.466 42.9458 197.466 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 43.1475C187.969 43.3492 188.133 43.5128 188.335 43.5128C188.536 43.5128 188.7 43.3492 188.7 43.1475C188.7 42.9458 188.536 42.7822 188.335 42.7822C188.133 42.7822 187.969 42.9458 187.969 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 43.1475C178.472 43.3492 178.636 43.5128 178.837 43.5128C179.039 43.5128 179.203 43.3492 179.203 43.1475C179.203 42.9458 179.039 42.7822 178.837 42.7822C178.636 42.7822 178.472 42.9458 178.472 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 43.1475C168.976 43.3492 169.139 43.5128 169.341 43.5128C169.542 43.5128 169.706 43.3492 169.706 43.1475C169.706 42.9458 169.542 42.7822 169.341 42.7822C169.139 42.7822 168.976 42.9458 168.976 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 43.1475C159.479 43.3492 159.642 43.5128 159.844 43.5128C160.045 43.5128 160.209 43.3492 160.209 43.1475C160.209 42.9458 160.045 42.7822 159.844 42.7822C159.642 42.7822 159.479 42.9458 159.479 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 43.1475C149.982 43.3492 150.145 43.5128 150.347 43.5128C150.549 43.5128 150.712 43.3492 150.712 43.1475C150.712 42.9458 150.549 42.7822 150.347 42.7822C150.145 42.7822 149.982 42.9458 149.982 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 43.1475C140.485 43.3492 140.649 43.5128 140.85 43.5128C141.052 43.5128 141.215 43.3492 141.215 43.1475C141.215 42.9458 141.052 42.7822 140.85 42.7822C140.649 42.7822 140.485 42.9458 140.485 43.1475Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 52.6441C225.957 52.8458 226.12 53.0093 226.322 53.0093C226.523 53.0093 226.687 52.8458 226.687 52.6441C226.687 52.4424 226.523 52.2788 226.322 52.2788C226.12 52.2788 225.957 52.4424 225.957 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 52.6441C216.46 52.8458 216.624 53.0093 216.825 53.0093C217.027 53.0093 217.19 52.8458 217.19 52.6441C217.19 52.4424 217.027 52.2788 216.825 52.2788C216.624 52.2788 216.46 52.4424 216.46 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 52.6441C206.963 52.8458 207.127 53.0093 207.328 53.0093C207.53 53.0093 207.693 52.8458 207.693 52.6441C207.693 52.4424 207.53 52.2788 207.328 52.2788C207.127 52.2788 206.963 52.4424 206.963 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 52.6441C197.466 52.8458 197.629 53.0093 197.831 53.0093C198.033 53.0093 198.196 52.8458 198.196 52.6441C198.196 52.4424 198.033 52.2788 197.831 52.2788C197.629 52.2788 197.466 52.4424 197.466 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 52.6441C187.969 52.8458 188.133 53.0093 188.335 53.0093C188.536 53.0093 188.7 52.8458 188.7 52.6441C188.7 52.4424 188.536 52.2788 188.335 52.2788C188.133 52.2788 187.969 52.4424 187.969 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 52.6441C178.472 52.8458 178.636 53.0093 178.837 53.0093C179.039 53.0093 179.203 52.8458 179.203 52.6441C179.203 52.4424 179.039 52.2788 178.837 52.2788C178.636 52.2788 178.472 52.4424 178.472 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 52.6441C168.976 52.8458 169.139 53.0093 169.341 53.0093C169.542 53.0093 169.706 52.8458 169.706 52.6441C169.706 52.4424 169.542 52.2788 169.341 52.2788C169.139 52.2788 168.976 52.4424 168.976 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 52.6441C159.479 52.8458 159.642 53.0093 159.844 53.0093C160.045 53.0093 160.209 52.8458 160.209 52.6441C160.209 52.4424 160.045 52.2788 159.844 52.2788C159.642 52.2788 159.479 52.4424 159.479 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 52.6441C149.982 52.8458 150.145 53.0093 150.347 53.0093C150.549 53.0093 150.712 52.8458 150.712 52.6441C150.712 52.4424 150.549 52.2788 150.347 52.2788C150.145 52.2788 149.982 52.4424 149.982 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 52.6441C140.485 52.8458 140.649 53.0093 140.85 53.0093C141.052 53.0093 141.215 52.8458 141.215 52.6441C141.215 52.4424 141.052 52.2788 140.85 52.2788C140.649 52.2788 140.485 52.4424 140.485 52.6441Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 62.1407C225.957 62.3424 226.12 62.5059 226.322 62.5059C226.523 62.5059 226.687 62.3424 226.687 62.1407C226.687 61.939 226.523 61.7754 226.322 61.7754C226.12 61.7754 225.957 61.939 225.957 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 62.1407C216.46 62.3424 216.624 62.5059 216.825 62.5059C217.027 62.5059 217.19 62.3424 217.19 62.1407C217.19 61.939 217.027 61.7754 216.825 61.7754C216.624 61.7754 216.46 61.939 216.46 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 62.1407C206.963 62.3424 207.127 62.5059 207.328 62.5059C207.53 62.5059 207.693 62.3424 207.693 62.1407C207.693 61.939 207.53 61.7754 207.328 61.7754C207.127 61.7754 206.963 61.939 206.963 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 62.1407C197.466 62.3424 197.629 62.5059 197.831 62.5059C198.033 62.5059 198.196 62.3424 198.196 62.1407C198.196 61.939 198.033 61.7754 197.831 61.7754C197.629 61.7754 197.466 61.939 197.466 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 62.1407C187.969 62.3424 188.133 62.5059 188.335 62.5059C188.536 62.5059 188.7 62.3424 188.7 62.1407C188.7 61.939 188.536 61.7754 188.335 61.7754C188.133 61.7754 187.969 61.939 187.969 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 62.1407C178.472 62.3424 178.636 62.5059 178.837 62.5059C179.039 62.5059 179.203 62.3424 179.203 62.1407C179.203 61.939 179.039 61.7754 178.837 61.7754C178.636 61.7754 178.472 61.939 178.472 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 62.1407C168.976 62.3424 169.139 62.5059 169.341 62.5059C169.542 62.5059 169.706 62.3424 169.706 62.1407C169.706 61.939 169.542 61.7754 169.341 61.7754C169.139 61.7754 168.976 61.939 168.976 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 62.1407C159.479 62.3424 159.642 62.5059 159.844 62.5059C160.045 62.5059 160.209 62.3424 160.209 62.1407C160.209 61.939 160.045 61.7754 159.844 61.7754C159.642 61.7754 159.479 61.939 159.479 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 62.1407C149.982 62.3424 150.145 62.5059 150.347 62.5059C150.549 62.5059 150.712 62.3424 150.712 62.1407C150.712 61.939 150.549 61.7754 150.347 61.7754C150.145 61.7754 149.982 61.939 149.982 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 62.1407C140.485 62.3424 140.649 62.5059 140.85 62.5059C141.052 62.5059 141.215 62.3424 141.215 62.1407C141.215 61.939 141.052 61.7754 140.85 61.7754C140.649 61.7754 140.485 61.939 140.485 62.1407Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 71.6385C225.957 71.8402 226.12 72.0037 226.322 72.0037C226.523 72.0037 226.687 71.8402 226.687 71.6385C226.687 71.4368 226.523 71.2732 226.322 71.2732C226.12 71.2732 225.957 71.4368 225.957 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 71.6385C216.46 71.8402 216.624 72.0037 216.825 72.0037C217.027 72.0037 217.19 71.8402 217.19 71.6385C217.19 71.4368 217.027 71.2732 216.825 71.2732C216.624 71.2732 216.46 71.4368 216.46 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 71.6385C206.963 71.8402 207.127 72.0037 207.328 72.0037C207.53 72.0037 207.693 71.8402 207.693 71.6385C207.693 71.4368 207.53 71.2732 207.328 71.2732C207.127 71.2732 206.963 71.4368 206.963 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 71.6385C197.466 71.8402 197.629 72.0037 197.831 72.0037C198.033 72.0037 198.196 71.8402 198.196 71.6385C198.196 71.4368 198.033 71.2732 197.831 71.2732C197.629 71.2732 197.466 71.4368 197.466 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 71.6385C187.969 71.8402 188.133 72.0037 188.335 72.0037C188.536 72.0037 188.7 71.8402 188.7 71.6385C188.7 71.4368 188.536 71.2732 188.335 71.2732C188.133 71.2732 187.969 71.4368 187.969 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 71.6385C178.472 71.8402 178.636 72.0037 178.837 72.0037C179.039 72.0037 179.203 71.8402 179.203 71.6385C179.203 71.4368 179.039 71.2732 178.837 71.2732C178.636 71.2732 178.472 71.4368 178.472 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 71.6385C168.976 71.8402 169.139 72.0037 169.341 72.0037C169.542 72.0037 169.706 71.8402 169.706 71.6385C169.706 71.4368 169.542 71.2732 169.341 71.2732C169.139 71.2732 168.976 71.4368 168.976 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 71.6385C159.479 71.8402 159.642 72.0037 159.844 72.0037C160.045 72.0037 160.209 71.8402 160.209 71.6385C160.209 71.4368 160.045 71.2732 159.844 71.2732C159.642 71.2732 159.479 71.4368 159.479 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 71.6385C149.982 71.8402 150.145 72.0037 150.347 72.0037C150.549 72.0037 150.712 71.8402 150.712 71.6385C150.712 71.4368 150.549 71.2732 150.347 71.2732C150.145 71.2732 149.982 71.4368 149.982 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 71.6385C140.485 71.8402 140.649 72.0037 140.85 72.0037C141.052 72.0037 141.215 71.8402 141.215 71.6385C141.215 71.4368 141.052 71.2732 140.85 71.2732C140.649 71.2732 140.485 71.4368 140.485 71.6385Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 81.1348C225.957 81.3365 226.12 81.5001 226.322 81.5001C226.523 81.5001 226.687 81.3365 226.687 81.1348C226.687 80.9331 226.523 80.7695 226.322 80.7695C226.12 80.7695 225.957 80.9331 225.957 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 81.1348C216.46 81.3365 216.624 81.5001 216.825 81.5001C217.027 81.5001 217.19 81.3365 217.19 81.1348C217.19 80.9331 217.027 80.7695 216.825 80.7695C216.624 80.7695 216.46 80.9331 216.46 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 81.1348C206.963 81.3365 207.127 81.5001 207.328 81.5001C207.53 81.5001 207.693 81.3365 207.693 81.1348C207.693 80.9331 207.53 80.7695 207.328 80.7695C207.127 80.7695 206.963 80.9331 206.963 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 81.1348C197.466 81.3365 197.629 81.5001 197.831 81.5001C198.033 81.5001 198.196 81.3365 198.196 81.1348C198.196 80.9331 198.033 80.7695 197.831 80.7695C197.629 80.7695 197.466 80.9331 197.466 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 81.1348C187.969 81.3365 188.133 81.5001 188.335 81.5001C188.536 81.5001 188.7 81.3365 188.7 81.1348C188.7 80.9331 188.536 80.7695 188.335 80.7695C188.133 80.7695 187.969 80.9331 187.969 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 81.1348C178.472 81.3365 178.636 81.5001 178.837 81.5001C179.039 81.5001 179.203 81.3365 179.203 81.1348C179.203 80.9331 179.039 80.7695 178.837 80.7695C178.636 80.7695 178.472 80.9331 178.472 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 81.1348C168.976 81.3365 169.139 81.5001 169.341 81.5001C169.542 81.5001 169.706 81.3365 169.706 81.1348C169.706 80.9331 169.542 80.7695 169.341 80.7695C169.139 80.7695 168.976 80.9331 168.976 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 81.1348C159.479 81.3365 159.642 81.5001 159.844 81.5001C160.045 81.5001 160.209 81.3365 160.209 81.1348C160.209 80.9331 160.045 80.7695 159.844 80.7695C159.642 80.7695 159.479 80.9331 159.479 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 81.1348C149.982 81.3365 150.145 81.5001 150.347 81.5001C150.549 81.5001 150.712 81.3365 150.712 81.1348C150.712 80.9331 150.549 80.7695 150.347 80.7695C150.145 80.7695 149.982 80.9331 149.982 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 81.1348C140.485 81.3365 140.649 81.5001 140.85 81.5001C141.052 81.5001 141.215 81.3365 141.215 81.1348C141.215 80.9331 141.052 80.7695 140.85 80.7695C140.649 80.7695 140.485 80.9331 140.485 81.1348Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 90.6326C225.957 90.8343 226.12 90.9979 226.322 90.9979C226.523 90.9979 226.687 90.8343 226.687 90.6326C226.687 90.4309 226.523 90.2673 226.322 90.2673C226.12 90.2673 225.957 90.4309 225.957 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 90.6326C216.46 90.8343 216.624 90.9979 216.825 90.9979C217.027 90.9979 217.19 90.8343 217.19 90.6326C217.19 90.4309 217.027 90.2673 216.825 90.2673C216.624 90.2673 216.46 90.4309 216.46 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 90.6326C206.963 90.8343 207.127 90.9979 207.328 90.9979C207.53 90.9979 207.693 90.8343 207.693 90.6326C207.693 90.4309 207.53 90.2673 207.328 90.2673C207.127 90.2673 206.963 90.4309 206.963 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 90.6326C197.466 90.8343 197.629 90.9979 197.831 90.9979C198.033 90.9979 198.196 90.8343 198.196 90.6326C198.196 90.4309 198.033 90.2673 197.831 90.2673C197.629 90.2673 197.466 90.4309 197.466 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 90.6326C187.969 90.8343 188.133 90.9979 188.335 90.9979C188.536 90.9979 188.7 90.8343 188.7 90.6326C188.7 90.4309 188.536 90.2673 188.335 90.2673C188.133 90.2673 187.969 90.4309 187.969 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 90.6326C178.472 90.8343 178.636 90.9979 178.837 90.9979C179.039 90.9979 179.203 90.8343 179.203 90.6326C179.203 90.4309 179.039 90.2673 178.837 90.2673C178.636 90.2673 178.472 90.4309 178.472 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 90.6326C168.976 90.8343 169.139 90.9979 169.341 90.9979C169.542 90.9979 169.706 90.8343 169.706 90.6326C169.706 90.4309 169.542 90.2673 169.341 90.2673C169.139 90.2673 168.976 90.4309 168.976 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 90.6326C159.479 90.8343 159.642 90.9979 159.844 90.9979C160.045 90.9979 160.209 90.8343 160.209 90.6326C160.209 90.4309 160.045 90.2673 159.844 90.2673C159.642 90.2673 159.479 90.4309 159.479 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 90.6326C149.982 90.8343 150.145 90.9979 150.347 90.9979C150.549 90.9979 150.712 90.8343 150.712 90.6326C150.712 90.4309 150.549 90.2673 150.347 90.2673C150.145 90.2673 149.982 90.4309 149.982 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 90.6326C140.485 90.8343 140.649 90.9979 140.85 90.9979C141.052 90.9979 141.215 90.8343 141.215 90.6326C141.215 90.4309 141.052 90.2673 140.85 90.2673C140.649 90.2673 140.485 90.4309 140.485 90.6326Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 100.129C225.957 100.331 226.12 100.494 226.322 100.494C226.523 100.494 226.687 100.331 226.687 100.129C226.687 99.9275 226.523 99.7639 226.322 99.7639C226.12 99.7639 225.957 99.9275 225.957 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 100.129C216.46 100.331 216.624 100.494 216.825 100.494C217.027 100.494 217.19 100.331 217.19 100.129C217.19 99.9275 217.027 99.7639 216.825 99.7639C216.624 99.7639 216.46 99.9275 216.46 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 100.129C206.963 100.331 207.127 100.494 207.328 100.494C207.53 100.494 207.693 100.331 207.693 100.129C207.693 99.9275 207.53 99.7639 207.328 99.7639C207.127 99.7639 206.963 99.9275 206.963 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 100.129C197.466 100.331 197.629 100.494 197.831 100.494C198.033 100.494 198.196 100.331 198.196 100.129C198.196 99.9275 198.033 99.7639 197.831 99.7639C197.629 99.7639 197.466 99.9275 197.466 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 100.129C187.969 100.331 188.133 100.494 188.335 100.494C188.536 100.494 188.7 100.331 188.7 100.129C188.7 99.9275 188.536 99.7639 188.335 99.7639C188.133 99.7639 187.969 99.9275 187.969 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 100.129C178.472 100.331 178.636 100.494 178.837 100.494C179.039 100.494 179.203 100.331 179.203 100.129C179.203 99.9275 179.039 99.7639 178.837 99.7639C178.636 99.7639 178.472 99.9275 178.472 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 100.129C168.976 100.331 169.139 100.494 169.341 100.494C169.542 100.494 169.706 100.331 169.706 100.129C169.706 99.9275 169.542 99.7639 169.341 99.7639C169.139 99.7639 168.976 99.9275 168.976 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 100.129C159.479 100.331 159.642 100.494 159.844 100.494C160.045 100.494 160.209 100.331 160.209 100.129C160.209 99.9275 160.045 99.7639 159.844 99.7639C159.642 99.7639 159.479 99.9275 159.479 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 100.129C149.982 100.331 150.145 100.494 150.347 100.494C150.549 100.494 150.712 100.331 150.712 100.129C150.712 99.9275 150.549 99.7639 150.347 99.7639C150.145 99.7639 149.982 99.9275 149.982 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 100.129C140.485 100.331 140.649 100.494 140.85 100.494C141.052 100.494 141.215 100.331 141.215 100.129C141.215 99.9275 141.052 99.7639 140.85 99.7639C140.649 99.7639 140.485 99.9275 140.485 100.129Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 109.626C225.957 109.827 226.12 109.991 226.322 109.991C226.523 109.991 226.687 109.827 226.687 109.626C226.687 109.424 226.523 109.26 226.322 109.26C226.12 109.26 225.957 109.424 225.957 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 109.626C216.46 109.827 216.624 109.991 216.825 109.991C217.027 109.991 217.19 109.827 217.19 109.626C217.19 109.424 217.027 109.26 216.825 109.26C216.624 109.26 216.46 109.424 216.46 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 109.626C206.963 109.827 207.127 109.991 207.328 109.991C207.53 109.991 207.693 109.827 207.693 109.626C207.693 109.424 207.53 109.26 207.328 109.26C207.127 109.26 206.963 109.424 206.963 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 109.626C197.466 109.827 197.629 109.991 197.831 109.991C198.033 109.991 198.196 109.827 198.196 109.626C198.196 109.424 198.033 109.26 197.831 109.26C197.629 109.26 197.466 109.424 197.466 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 109.626C187.969 109.827 188.133 109.991 188.335 109.991C188.536 109.991 188.7 109.827 188.7 109.626C188.7 109.424 188.536 109.26 188.335 109.26C188.133 109.26 187.969 109.424 187.969 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 109.626C178.472 109.827 178.636 109.991 178.837 109.991C179.039 109.991 179.203 109.827 179.203 109.626C179.203 109.424 179.039 109.26 178.837 109.26C178.636 109.26 178.472 109.424 178.472 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 109.626C168.976 109.827 169.139 109.991 169.341 109.991C169.542 109.991 169.706 109.827 169.706 109.626C169.706 109.424 169.542 109.26 169.341 109.26C169.139 109.26 168.976 109.424 168.976 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 109.626C159.479 109.827 159.642 109.991 159.844 109.991C160.045 109.991 160.209 109.827 160.209 109.626C160.209 109.424 160.045 109.26 159.844 109.26C159.642 109.26 159.479 109.424 159.479 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 109.626C149.982 109.827 150.145 109.991 150.347 109.991C150.549 109.991 150.712 109.827 150.712 109.626C150.712 109.424 150.549 109.26 150.347 109.26C150.145 109.26 149.982 109.424 149.982 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 109.626C140.485 109.827 140.649 109.991 140.85 109.991C141.052 109.991 141.215 109.827 141.215 109.626C141.215 109.424 141.052 109.26 140.85 109.26C140.649 109.26 140.485 109.424 140.485 109.626Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 119.122C225.957 119.324 226.12 119.487 226.322 119.487C226.523 119.487 226.687 119.324 226.687 119.122C226.687 118.92 226.523 118.757 226.322 118.757C226.12 118.757 225.957 118.92 225.957 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 119.122C216.46 119.324 216.624 119.487 216.825 119.487C217.027 119.487 217.19 119.324 217.19 119.122C217.19 118.92 217.027 118.757 216.825 118.757C216.624 118.757 216.46 118.92 216.46 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 119.122C206.963 119.324 207.127 119.487 207.328 119.487C207.53 119.487 207.693 119.324 207.693 119.122C207.693 118.92 207.53 118.757 207.328 118.757C207.127 118.757 206.963 118.92 206.963 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 119.122C197.466 119.324 197.629 119.487 197.831 119.487C198.033 119.487 198.196 119.324 198.196 119.122C198.196 118.92 198.033 118.757 197.831 118.757C197.629 118.757 197.466 118.92 197.466 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 119.122C187.969 119.324 188.133 119.487 188.335 119.487C188.536 119.487 188.7 119.324 188.7 119.122C188.7 118.92 188.536 118.757 188.335 118.757C188.133 118.757 187.969 118.92 187.969 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 119.122C178.472 119.324 178.636 119.487 178.837 119.487C179.039 119.487 179.203 119.324 179.203 119.122C179.203 118.92 179.039 118.757 178.837 118.757C178.636 118.757 178.472 118.92 178.472 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 119.122C168.976 119.324 169.139 119.487 169.341 119.487C169.542 119.487 169.706 119.324 169.706 119.122C169.706 118.92 169.542 118.757 169.341 118.757C169.139 118.757 168.976 118.92 168.976 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 119.122C159.479 119.324 159.642 119.487 159.844 119.487C160.045 119.487 160.209 119.324 160.209 119.122C160.209 118.92 160.045 118.757 159.844 118.757C159.642 118.757 159.479 118.92 159.479 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 119.122C149.982 119.324 150.145 119.487 150.347 119.487C150.549 119.487 150.712 119.324 150.712 119.122C150.712 118.92 150.549 118.757 150.347 118.757C150.145 118.757 149.982 118.92 149.982 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 119.122C140.485 119.324 140.649 119.487 140.85 119.487C141.052 119.487 141.215 119.324 141.215 119.122C141.215 118.92 141.052 118.757 140.85 118.757C140.649 118.757 140.485 118.92 140.485 119.122Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 128.62C225.957 128.822 226.12 128.985 226.322 128.985C226.523 128.985 226.687 128.822 226.687 128.62C226.687 128.418 226.523 128.255 226.322 128.255C226.12 128.255 225.957 128.418 225.957 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 128.62C216.46 128.822 216.624 128.985 216.825 128.985C217.027 128.985 217.19 128.822 217.19 128.62C217.19 128.418 217.027 128.255 216.825 128.255C216.624 128.255 216.46 128.418 216.46 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 128.62C206.963 128.822 207.127 128.985 207.328 128.985C207.53 128.985 207.693 128.822 207.693 128.62C207.693 128.418 207.53 128.255 207.328 128.255C207.127 128.255 206.963 128.418 206.963 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 128.62C197.466 128.822 197.629 128.985 197.831 128.985C198.033 128.985 198.196 128.822 198.196 128.62C198.196 128.418 198.033 128.255 197.831 128.255C197.629 128.255 197.466 128.418 197.466 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 128.62C187.969 128.822 188.133 128.985 188.335 128.985C188.536 128.985 188.7 128.822 188.7 128.62C188.7 128.418 188.536 128.255 188.335 128.255C188.133 128.255 187.969 128.418 187.969 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 128.62C178.472 128.822 178.636 128.985 178.837 128.985C179.039 128.985 179.203 128.822 179.203 128.62C179.203 128.418 179.039 128.255 178.837 128.255C178.636 128.255 178.472 128.418 178.472 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 128.62C168.976 128.822 169.139 128.985 169.341 128.985C169.542 128.985 169.706 128.822 169.706 128.62C169.706 128.418 169.542 128.255 169.341 128.255C169.139 128.255 168.976 128.418 168.976 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 128.62C159.479 128.822 159.642 128.985 159.844 128.985C160.045 128.985 160.209 128.822 160.209 128.62C160.209 128.418 160.045 128.255 159.844 128.255C159.642 128.255 159.479 128.418 159.479 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 128.62C149.982 128.822 150.145 128.985 150.347 128.985C150.549 128.985 150.712 128.822 150.712 128.62C150.712 128.418 150.549 128.255 150.347 128.255C150.145 128.255 149.982 128.418 149.982 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 128.62C140.485 128.822 140.649 128.985 140.85 128.985C141.052 128.985 141.215 128.822 141.215 128.62C141.215 128.418 141.052 128.255 140.85 128.255C140.649 128.255 140.485 128.418 140.485 128.62Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 138.116C225.957 138.318 226.12 138.482 226.322 138.482C226.523 138.482 226.687 138.318 226.687 138.116C226.687 137.915 226.523 137.751 226.322 137.751C226.12 137.751 225.957 137.915 225.957 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 138.116C216.46 138.318 216.624 138.482 216.825 138.482C217.027 138.482 217.19 138.318 217.19 138.116C217.19 137.915 217.027 137.751 216.825 137.751C216.624 137.751 216.46 137.915 216.46 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 138.116C206.963 138.318 207.127 138.482 207.328 138.482C207.53 138.482 207.693 138.318 207.693 138.116C207.693 137.915 207.53 137.751 207.328 137.751C207.127 137.751 206.963 137.915 206.963 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 138.116C197.466 138.318 197.629 138.482 197.831 138.482C198.033 138.482 198.196 138.318 198.196 138.116C198.196 137.915 198.033 137.751 197.831 137.751C197.629 137.751 197.466 137.915 197.466 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 138.116C187.969 138.318 188.133 138.482 188.335 138.482C188.536 138.482 188.7 138.318 188.7 138.116C188.7 137.915 188.536 137.751 188.335 137.751C188.133 137.751 187.969 137.915 187.969 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 138.116C178.472 138.318 178.636 138.482 178.837 138.482C179.039 138.482 179.203 138.318 179.203 138.116C179.203 137.915 179.039 137.751 178.837 137.751C178.636 137.751 178.472 137.915 178.472 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 138.116C168.976 138.318 169.139 138.482 169.341 138.482C169.542 138.482 169.706 138.318 169.706 138.116C169.706 137.915 169.542 137.751 169.341 137.751C169.139 137.751 168.976 137.915 168.976 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 138.116C159.479 138.318 159.642 138.482 159.844 138.482C160.045 138.482 160.209 138.318 160.209 138.116C160.209 137.915 160.045 137.751 159.844 137.751C159.642 137.751 159.479 137.915 159.479 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 138.116C149.982 138.318 150.145 138.482 150.347 138.482C150.549 138.482 150.712 138.318 150.712 138.116C150.712 137.915 150.549 137.751 150.347 137.751C150.145 137.751 149.982 137.915 149.982 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 138.116C140.485 138.318 140.649 138.482 140.85 138.482C141.052 138.482 141.215 138.318 141.215 138.116C141.215 137.915 141.052 137.751 140.85 137.751C140.649 137.751 140.485 137.915 140.485 138.116Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 147.613C225.957 147.814 226.12 147.978 226.322 147.978C226.523 147.978 226.687 147.814 226.687 147.613C226.687 147.411 226.523 147.248 226.322 147.248C226.12 147.248 225.957 147.411 225.957 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 147.613C216.46 147.814 216.624 147.978 216.825 147.978C217.027 147.978 217.19 147.814 217.19 147.613C217.19 147.411 217.027 147.248 216.825 147.248C216.624 147.248 216.46 147.411 216.46 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 147.613C206.963 147.814 207.127 147.978 207.328 147.978C207.53 147.978 207.693 147.814 207.693 147.613C207.693 147.411 207.53 147.248 207.328 147.248C207.127 147.248 206.963 147.411 206.963 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 147.613C197.466 147.814 197.629 147.978 197.831 147.978C198.033 147.978 198.196 147.814 198.196 147.613C198.196 147.411 198.033 147.248 197.831 147.248C197.629 147.248 197.466 147.411 197.466 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 147.613C187.969 147.814 188.133 147.978 188.335 147.978C188.536 147.978 188.7 147.814 188.7 147.613C188.7 147.411 188.536 147.248 188.335 147.248C188.133 147.248 187.969 147.411 187.969 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 147.613C178.472 147.814 178.636 147.978 178.837 147.978C179.039 147.978 179.203 147.814 179.203 147.613C179.203 147.411 179.039 147.248 178.837 147.248C178.636 147.248 178.472 147.411 178.472 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 147.613C168.976 147.814 169.139 147.978 169.341 147.978C169.542 147.978 169.706 147.814 169.706 147.613C169.706 147.411 169.542 147.248 169.341 147.248C169.139 147.248 168.976 147.411 168.976 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 147.613C159.479 147.814 159.642 147.978 159.844 147.978C160.045 147.978 160.209 147.814 160.209 147.613C160.209 147.411 160.045 147.248 159.844 147.248C159.642 147.248 159.479 147.411 159.479 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 147.613C149.982 147.814 150.145 147.978 150.347 147.978C150.549 147.978 150.712 147.814 150.712 147.613C150.712 147.411 150.549 147.248 150.347 147.248C150.145 147.248 149.982 147.411 149.982 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 147.613C140.485 147.814 140.649 147.978 140.85 147.978C141.052 147.978 141.215 147.814 141.215 147.613C141.215 147.411 141.052 147.248 140.85 147.248C140.649 147.248 140.485 147.411 140.485 147.613Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.957 157.111C225.957 157.312 226.12 157.476 226.322 157.476C226.523 157.476 226.687 157.312 226.687 157.111C226.687 156.909 226.523 156.745 226.322 156.745C226.12 156.745 225.957 156.909 225.957 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46 157.111C216.46 157.312 216.624 157.476 216.825 157.476C217.027 157.476 217.19 157.312 217.19 157.111C217.19 156.909 217.027 156.745 216.825 156.745C216.624 156.745 216.46 156.909 216.46 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.963 157.111C206.963 157.312 207.127 157.476 207.328 157.476C207.53 157.476 207.693 157.312 207.693 157.111C207.693 156.909 207.53 156.745 207.328 156.745C207.127 156.745 206.963 156.909 206.963 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.466 157.111C197.466 157.312 197.629 157.476 197.831 157.476C198.033 157.476 198.196 157.312 198.196 157.111C198.196 156.909 198.033 156.745 197.831 156.745C197.629 156.745 197.466 156.909 197.466 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.969 157.111C187.969 157.312 188.133 157.476 188.335 157.476C188.536 157.476 188.7 157.312 188.7 157.111C188.7 156.909 188.536 156.745 188.335 156.745C188.133 156.745 187.969 156.909 187.969 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.472 157.111C178.472 157.312 178.636 157.476 178.837 157.476C179.039 157.476 179.203 157.312 179.203 157.111C179.203 156.909 179.039 156.745 178.837 156.745C178.636 156.745 178.472 156.909 178.472 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.976 157.111C168.976 157.312 169.139 157.476 169.341 157.476C169.542 157.476 169.706 157.312 169.706 157.111C169.706 156.909 169.542 156.745 169.341 156.745C169.139 156.745 168.976 156.909 168.976 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.479 157.111C159.479 157.312 159.642 157.476 159.844 157.476C160.045 157.476 160.209 157.312 160.209 157.111C160.209 156.909 160.045 156.745 159.844 156.745C159.642 156.745 159.479 156.909 159.479 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.982 157.111C149.982 157.312 150.145 157.476 150.347 157.476C150.549 157.476 150.712 157.312 150.712 157.111C150.712 156.909 150.549 156.745 150.347 156.745C150.145 156.745 149.982 156.909 149.982 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.485 157.111C140.485 157.312 140.649 157.476 140.85 157.476C141.052 157.476 141.215 157.312 141.215 157.111C141.215 156.909 141.052 156.745 140.85 156.745C140.649 156.745 140.485 156.909 140.485 157.111Z",
    fill: "#22328A",
    fillOpacity: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdddii_664_31722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 61.5874,
    y: 44.9741,
    width: 52.5982,
    height: 52.5982,
    rx: 5.84424,
    fill: "url(#paint0_linear_664_31722)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2605 61.3372L87.884 67.9606H81.2605V74.5841L87.884 81.2076V74.5841H94.5074L87.884 67.9606H94.5074V61.3372H81.2605Z",
    fill: "#2748B7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bdddii_664_31722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 158.018,
    y: 44.9741,
    width: 52.5982,
    height: 52.5982,
    rx: 5.84424,
    fill: "url(#paint1_linear_664_31722)",
    shapeRendering: "crispEdges"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdddii_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_664_31722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.1201,
    y: 25.98,
    width: 113.963,
    height: 90.5857,
    rx: 5.84424,
    fill: "url(#paint2_linear_664_31722)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.1201,
    y: 25.98,
    width: 113.963,
    height: 90.5857,
    rx: 5.84424,
    fill: "url(#paint3_linear_664_31722)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.73053,
    height: 90.5857,
    transform: "translate(135.736 25.9797)",
    fill: "#0E0948",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.736,
    y: 31.0923,
    width: 0.73053,
    height: 37.257,
    rx: 0.365265,
    fill: "url(#paint4_linear_664_31722)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.736,
    y: 87.3435,
    width: 0.73053,
    height: 23.377,
    rx: 0.365265,
    fill: "url(#paint5_linear_664_31722)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_664_31722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.317 64.6984C123.721 64.6984 124.048 64.3713 124.048 63.9678C124.048 63.5644 123.721 63.2373 123.317 63.2373C122.914 63.2373 122.587 63.5644 122.587 63.9678C122.587 64.3713 122.914 64.6984 123.317 64.6984Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.359 96.111C112.763 96.111 113.09 95.7839 113.09 95.3804C113.09 94.977 112.763 94.6499 112.359 94.6499C111.956 94.6499 111.629 94.977 111.629 95.3804C111.629 95.7839 111.956 96.111 112.359 96.111Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.048 55.2008C124.451 55.2008 124.778 54.8737 124.778 54.4703C124.778 54.0668 124.451 53.7397 124.048 53.7397C123.644 53.7397 123.317 54.0668 123.317 54.4703C123.317 54.8737 123.644 55.2008 124.048 55.2008Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.281 89.536C115.685 89.536 116.012 89.2089 116.012 88.8055C116.012 88.402 115.685 88.075 115.281 88.075C114.878 88.075 114.551 88.402 114.551 88.8055C114.551 89.2089 114.878 89.536 115.281 89.536Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.359 107.8C112.763 107.8 113.09 107.473 113.09 107.069C113.09 106.666 112.763 106.339 112.359 106.339C111.956 106.339 111.629 106.666 111.629 107.069C111.629 107.473 111.956 107.8 112.359 107.8Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.527 100.494C129.728 100.494 129.892 100.331 129.892 100.129C129.892 99.9275 129.728 99.7639 129.527 99.7639C129.325 99.7639 129.161 99.9275 129.161 100.129C129.161 100.331 129.325 100.494 129.527 100.494Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.617 77.1177C88.8187 77.1177 88.9822 76.9542 88.9822 76.7525C88.9822 76.5507 88.8187 76.3872 88.617 76.3872C88.4152 76.3872 88.2517 76.5507 88.2517 76.7525C88.2517 76.9542 88.4152 77.1177 88.617 77.1177Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8086 59.5843C91.0104 59.5843 91.1739 59.4208 91.1739 59.219C91.1739 59.0173 91.0104 58.8538 90.8086 58.8538C90.6069 58.8538 90.4434 59.0173 90.4434 59.219C90.4434 59.4208 90.6069 59.5843 90.8086 59.5843Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6949 100.494C85.8966 100.494 86.0601 100.331 86.0601 100.129C86.0601 99.9275 85.8966 99.7639 85.6949 99.7639C85.4931 99.7639 85.3296 99.9275 85.3296 100.129C85.3296 100.331 85.4931 100.494 85.6949 100.494Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1917 42.7825C95.3934 42.7825 95.5569 42.619 95.5569 42.4173C95.5569 42.2155 95.3934 42.052 95.1917 42.052C94.99 42.052 94.8264 42.2155 94.8264 42.4173C94.8264 42.619 94.99 42.7825 95.1917 42.7825Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4612 63.9678C94.6629 63.9678 94.8265 63.8043 94.8265 63.6026C94.8265 63.4008 94.6629 63.2373 94.4612 63.2373C94.2595 63.2373 94.0959 63.4008 94.0959 63.6026C94.0959 63.8043 94.2595 63.9678 94.4612 63.9678Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9224 91.7283C96.1241 91.7283 96.2877 91.5648 96.2877 91.3631C96.2877 91.1613 96.1241 90.9978 95.9224 90.9978C95.7207 90.9978 95.5571 91.1613 95.5571 91.3631C95.5571 91.5648 95.7207 91.7283 95.9224 91.7283Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.377 85.8839C116.579 85.8839 116.742 85.7203 116.742 85.5186C116.742 85.3169 116.579 85.1533 116.377 85.1533C116.175 85.1533 116.012 85.3169 116.012 85.5186C116.012 85.7203 116.175 85.8839 116.377 85.8839Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.299 48.627C119.501 48.627 119.665 48.4635 119.665 48.2617C119.665 48.06 119.501 47.8965 119.299 47.8965C119.098 47.8965 118.934 48.06 118.934 48.2617C118.934 48.4635 119.098 48.627 119.299 48.627Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.838 55.2005C118.04 55.2005 118.203 55.037 118.203 54.8352C118.203 54.6335 118.04 54.47 117.838 54.47C117.636 54.47 117.473 54.6335 117.473 54.8352C117.473 55.037 117.636 55.2005 117.838 55.2005Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.335 55.2005C127.537 55.2005 127.7 55.037 127.7 54.8352C127.7 54.6335 127.537 54.47 127.335 54.47C127.133 54.47 126.97 54.6335 126.97 54.8352C126.97 55.037 127.133 55.2005 127.335 55.2005Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8865 73.4644C88.0882 73.4644 88.2518 73.3009 88.2518 73.0992C88.2518 72.8974 88.0882 72.7339 87.8865 72.7339C87.6848 72.7339 87.5212 72.8974 87.5212 73.0992C87.5212 73.3009 87.6848 73.4644 87.8865 73.4644Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.952 44.2432C123.154 44.2432 123.317 44.0797 123.317 43.878C123.317 43.6762 123.154 43.5127 122.952 43.5127C122.75 43.5127 122.587 43.6762 122.587 43.878C122.587 44.0797 122.75 44.2432 122.952 44.2432Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.341 69.8123C108.543 69.8123 108.707 69.6488 108.707 69.4471C108.707 69.2453 108.543 69.0818 108.341 69.0818C108.14 69.0818 107.976 69.2453 107.976 69.4471C107.976 69.6488 108.14 69.8123 108.341 69.8123Z",
    fill: "#10049B",
    fillOpacity: 0.24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.305 35.4771C100.507 35.4771 100.671 35.3136 100.671 35.1118C100.671 34.9101 100.507 34.7466 100.305 34.7466C100.104 34.7466 99.9402 34.9101 99.9402 35.1118C99.9402 35.3136 100.104 35.4771 100.305 35.4771Z",
    fill: "#10049B",
    fillOpacity: 0.24
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_664_31722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.581 33.6519C141.581 33.4502 141.417 33.2866 141.215 33.2866C141.014 33.2866 140.85 33.4502 140.85 33.6519V34.3824C140.85 34.5841 141.014 34.7477 141.215 34.7477C141.417 34.7477 141.581 34.5841 141.581 34.3824V33.6519Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.581 39.4951C141.581 39.2934 141.417 39.1299 141.215 39.1299C141.014 39.1299 140.85 39.2934 140.85 39.4951V40.2257C140.85 40.4274 141.014 40.5909 141.215 40.5909C141.417 40.5909 141.581 40.4274 141.581 40.2257V39.4951Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.581 45.3396C141.581 45.1379 141.417 44.9744 141.215 44.9744C141.014 44.9744 140.85 45.1379 140.85 45.3396V46.0702C140.85 46.2719 141.014 46.4354 141.215 46.4354C141.417 46.4354 141.581 46.2719 141.581 46.0702V45.3396Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.581 51.1841C141.581 50.9824 141.417 50.8188 141.215 50.8188C141.014 50.8188 140.85 50.9824 140.85 51.1841V51.9146C140.85 52.1164 141.014 52.2799 141.215 52.2799C141.417 52.2799 141.581 52.1164 141.581 51.9146V51.1841Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.581 57.0286C141.581 56.8269 141.417 56.6633 141.215 56.6633C141.014 56.6633 140.85 56.8269 140.85 57.0286V57.7591C140.85 57.9609 141.014 58.1244 141.215 58.1244C141.417 58.1244 141.581 57.9609 141.581 57.7591V57.0286Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.581 62.8719C141.581 62.6701 141.417 62.5066 141.215 62.5066C141.014 62.5066 140.85 62.6701 140.85 62.8719V63.6024C140.85 63.8041 141.014 63.9677 141.215 63.9677C141.417 63.9677 141.581 63.8041 141.581 63.6024V62.8719Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.581 68.7176C141.581 68.5158 141.417 68.3523 141.215 68.3523C141.014 68.3523 140.85 68.5158 140.85 68.7176V69.4481C140.85 69.6498 141.014 69.8134 141.215 69.8134C141.417 69.8134 141.581 69.6498 141.581 69.4481V68.7176Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.581 74.5608C141.581 74.3591 141.417 74.1956 141.215 74.1956C141.014 74.1956 140.85 74.3591 140.85 74.5608V75.2914C140.85 75.4931 141.014 75.6566 141.215 75.6566C141.417 75.6566 141.581 75.4931 141.581 75.2914V74.5608Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.581 80.4053C141.581 80.2036 141.417 80.04 141.215 80.04C141.014 80.04 140.85 80.2036 140.85 80.4053V81.1358C140.85 81.3376 141.014 81.5011 141.215 81.5011C141.417 81.5011 141.581 81.3376 141.581 81.1358V80.4053Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.191 39.1299H146.694C146.291 39.1299 145.964 39.457 145.964 39.8604C145.964 40.2639 146.291 40.5909 146.694 40.5909H156.191C156.595 40.5909 156.922 40.2639 156.922 39.8604C156.922 39.457 156.595 39.1299 156.191 39.1299Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.035 39.1299H159.844C159.44 39.1299 159.113 39.457 159.113 39.8604C159.113 40.2639 159.44 40.5909 159.844 40.5909H162.035C162.439 40.5909 162.766 40.2639 162.766 39.8604C162.766 39.457 162.439 39.1299 162.035 39.1299Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.071 39.1299H165.688C165.285 39.1299 164.958 39.457 164.958 39.8604C164.958 40.2639 165.285 40.5909 165.688 40.5909H170.071C170.475 40.5909 170.802 40.2639 170.802 39.8604C170.802 39.457 170.475 39.1299 170.071 39.1299Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.844 50.8188H152.539C152.135 50.8188 151.808 51.1459 151.808 51.5494C151.808 51.9528 152.135 52.2799 152.539 52.2799H159.844C160.247 52.2799 160.574 51.9528 160.574 51.5494C160.574 51.1459 160.247 50.8188 159.844 50.8188Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.802 50.8188H163.497C163.093 50.8188 162.766 51.1459 162.766 51.5494C162.766 51.9528 163.093 52.2799 163.497 52.2799H170.802C171.205 52.2799 171.532 51.9528 171.532 51.5494C171.532 51.1459 171.205 50.8188 170.802 50.8188Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.221 50.8188H174.455C174.051 50.8188 173.724 51.1459 173.724 51.5494C173.724 51.9528 174.051 52.2799 174.455 52.2799H183.221C183.624 52.2799 183.952 51.9528 183.952 51.5494C183.952 51.1459 183.624 50.8188 183.221 50.8188Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.604 50.8188H186.874C186.47 50.8188 186.143 51.1459 186.143 51.5494C186.143 51.9528 186.47 52.2799 186.874 52.2799H187.604C188.008 52.2799 188.335 51.9528 188.335 51.5494C188.335 51.1459 188.008 50.8188 187.604 50.8188Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.347 33.2866H146.694C146.291 33.2866 145.964 33.6137 145.964 34.0172C145.964 34.4206 146.291 34.7477 146.694 34.7477H150.347C150.751 34.7477 151.078 34.4206 151.078 34.0172C151.078 33.6137 150.751 33.2866 150.347 33.2866Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.191 33.2866H154C153.596 33.2866 153.269 33.6137 153.269 34.0172C153.269 34.4206 153.596 34.7477 154 34.7477H156.191C156.595 34.7477 156.922 34.4206 156.922 34.0172C156.922 33.6137 156.595 33.2866 156.191 33.2866Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.185 33.2866H159.844C159.44 33.2866 159.113 33.6137 159.113 34.0172C159.113 34.4206 159.44 34.7477 159.844 34.7477H175.185C175.588 34.7477 175.915 34.4206 175.915 34.0172C175.915 33.6137 175.588 33.2866 175.185 33.2866Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88 44.9744H152.539C152.135 44.9744 151.808 45.3014 151.808 45.7049C151.808 46.1084 152.135 46.4354 152.539 46.4354H167.88C168.283 46.4354 168.61 46.1084 168.61 45.7049C168.61 45.3014 168.283 44.9744 167.88 44.9744Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.838 44.9744H171.532C171.129 44.9744 170.802 45.3014 170.802 45.7049C170.802 46.1084 171.129 46.4354 171.532 46.4354H178.838C179.241 46.4354 179.568 46.1084 179.568 45.7049C179.568 45.3014 179.241 44.9744 178.838 44.9744Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.873 44.9744H182.49C182.087 44.9744 181.76 45.3014 181.76 45.7049C181.76 46.1084 182.087 46.4354 182.49 46.4354H186.873C187.277 46.4354 187.604 46.1084 187.604 45.7049C187.604 45.3014 187.277 44.9744 186.873 44.9744Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.844 56.6633H156.922C156.518 56.6633 156.191 56.9904 156.191 57.3939C156.191 57.7973 156.518 58.1244 156.922 58.1244H159.844C160.248 58.1244 160.575 57.7973 160.575 57.3939C160.575 56.9904 160.248 56.6633 159.844 56.6633Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.802 56.6633H163.497C163.093 56.6633 162.766 56.9904 162.766 57.3939C162.766 57.7973 163.093 58.1244 163.497 58.1244H170.802C171.205 58.1244 171.532 57.7973 171.532 57.3939C171.532 56.9904 171.205 56.6633 170.802 56.6633Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.916 56.6633H174.455C174.051 56.6633 173.724 56.9904 173.724 57.3939C173.724 57.7973 174.051 58.1244 174.455 58.1244H175.916C176.319 58.1244 176.646 57.7973 176.646 57.3939C176.646 56.9904 176.319 56.6633 175.916 56.6633Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.682 56.6633H179.568C179.164 56.6633 178.837 56.9904 178.837 57.3939C178.837 57.7973 179.164 58.1244 179.568 58.1244H184.682C185.085 58.1244 185.412 57.7973 185.412 57.3939C185.412 56.9904 185.085 56.6633 184.682 56.6633Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.078 62.5066H146.694C146.291 62.5066 145.964 62.8337 145.964 63.2371C145.964 63.6406 146.291 63.9677 146.694 63.9677H151.078C151.481 63.9677 151.808 63.6406 151.808 63.2371C151.808 62.8337 151.481 62.5066 151.078 62.5066Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.922 62.5066H154.73C154.327 62.5066 154 62.8337 154 63.2371C154 63.6406 154.327 63.9677 154.73 63.9677H156.922C157.325 63.9677 157.652 63.6406 157.652 63.2371C157.652 62.8337 157.325 62.5066 156.922 62.5066Z",
    fill: "#1A50BD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.376 62.5066H160.574C160.171 62.5066 159.844 62.8337 159.844 63.2371C159.844 63.6406 160.171 63.9677 160.574 63.9677H177.376C177.78 63.9677 178.107 63.6406 178.107 63.2371C178.107 62.8337 177.78 62.5066 177.376 62.5066Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.76 62.5066H181.029C180.626 62.5066 180.299 62.8337 180.299 63.2371C180.299 63.6406 180.626 63.9677 181.029 63.9677H181.76C182.163 63.9677 182.49 63.6406 182.49 63.2371C182.49 62.8337 182.163 62.5066 181.76 62.5066Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.078 74.1956H146.694C146.291 74.1956 145.964 74.5226 145.964 74.9261C145.964 75.3295 146.291 75.6566 146.694 75.6566H151.078C151.481 75.6566 151.808 75.3295 151.808 74.9261C151.808 74.5226 151.481 74.1956 151.078 74.1956Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.496 74.1956H154.73C154.327 74.1956 154 74.5226 154 74.9261C154 75.3295 154.327 75.6566 154.73 75.6566H163.496C163.9 75.6566 164.227 75.3295 164.227 74.9261C164.227 74.5226 163.9 74.1956 163.496 74.1956Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.341 74.1956H167.149C166.746 74.1956 166.418 74.5226 166.418 74.9261C166.418 75.3295 166.746 75.6566 167.149 75.6566H169.341C169.744 75.6566 170.071 75.3295 170.071 74.9261C170.071 74.5226 169.744 74.1956 169.341 74.1956Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.568 74.1956H172.993C172.59 74.1956 172.263 74.5226 172.263 74.9261C172.263 75.3295 172.59 75.6566 172.993 75.6566H179.568C179.971 75.6566 180.299 75.3295 180.299 74.9261C180.299 74.5226 179.971 74.1956 179.568 74.1956Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.844 68.3523H152.539C152.135 68.3523 151.808 68.6794 151.808 69.0828C151.808 69.4863 152.135 69.8134 152.539 69.8134H159.844C160.247 69.8134 160.574 69.4863 160.574 69.0828C160.574 68.6794 160.247 68.3523 159.844 68.3523Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.88 68.3523H163.497C163.093 68.3523 162.766 68.6794 162.766 69.0828C162.766 69.4863 163.093 69.8134 163.497 69.8134H167.88C168.283 69.8134 168.61 69.4863 168.61 69.0828C168.61 68.6794 168.283 68.3523 167.88 68.3523Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.299 68.3523H171.532C171.129 68.3523 170.802 68.6794 170.802 69.0828C170.802 69.4863 171.129 69.8134 171.532 69.8134H180.299C180.702 69.8134 181.029 69.4863 181.029 69.0828C181.029 68.6794 180.702 68.3523 180.299 68.3523Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.682 68.3523H183.951C183.548 68.3523 183.221 68.6794 183.221 69.0828C183.221 69.4863 183.548 69.8134 183.951 69.8134H184.682C185.085 69.8134 185.412 69.4863 185.412 69.0828C185.412 68.6794 185.085 68.3523 184.682 68.3523Z",
    fill: "#0E0948",
    fillOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_664_31722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.335,
    y: 62.5063,
    width: 17.5327,
    height: 17.5327,
    rx: 8.76636,
    fill: "#4F78FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_664_31722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.701 69.4602C137.701 69.2837 137.558 69.1406 137.382 69.1406C137.205 69.1406 137.062 69.2837 137.062 69.4602C137.062 70.494 136.834 71.1653 136.416 71.5836C135.997 72.0018 135.326 72.2302 134.292 72.2302C134.116 72.2302 133.973 72.3732 133.973 72.5498C133.973 72.7263 134.116 72.8694 134.292 72.8694C135.326 72.8694 135.997 73.0977 136.416 73.516C136.834 73.9342 137.062 74.6055 137.062 75.6393C137.062 75.8158 137.205 75.9589 137.382 75.9589C137.558 75.9589 137.701 75.8158 137.701 75.6393C137.701 74.6055 137.93 73.9342 138.348 73.516C138.766 73.0977 139.438 72.8694 140.471 72.8694C140.648 72.8694 140.791 72.7263 140.791 72.5498C140.791 72.3732 140.648 72.2302 140.471 72.2302C139.438 72.2302 138.766 72.0018 138.348 71.5836C137.93 71.1653 137.701 70.494 137.701 69.4602Z",
    fill: "url(#paint6_linear_664_31722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.079 66.9033C134.079 66.7268 133.936 66.5837 133.76 66.5837C133.583 66.5837 133.44 66.7268 133.44 66.9033C133.44 67.5672 133.293 67.9722 133.049 68.2166C132.804 68.4609 132.399 68.6079 131.735 68.6079C131.559 68.6079 131.416 68.751 131.416 68.9275C131.416 69.104 131.559 69.2471 131.735 69.2471C132.399 69.2471 132.804 69.3941 133.049 69.6385C133.293 69.8828 133.44 70.2879 133.44 70.9517C133.44 71.1282 133.583 71.2713 133.76 71.2713C133.936 71.2713 134.079 71.1282 134.079 70.9517C134.079 70.2879 134.226 69.8828 134.471 69.6385C134.715 69.3941 135.12 69.2471 135.784 69.2471C135.96 69.2471 136.103 69.104 136.103 68.9275C136.103 68.751 135.96 68.6079 135.784 68.6079C135.12 68.6079 134.715 68.4609 134.471 68.2166C134.226 67.9722 134.079 67.5672 134.079 66.9033Z",
    fill: "url(#paint7_linear_664_31722)"
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bdddii_664_31722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.191,
    y: 83.4082,
    width: 92.0431,
    height: 29.7943,
    rx: 6.01876,
    fill: "url(#paint8_linear_664_31722)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_664_31722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.704 98.305C164.704 93.3189 168.746 89.2769 173.732 89.2769C178.718 89.2769 182.76 93.3189 182.76 98.305C182.76 103.291 178.718 107.333 173.732 107.333C168.746 107.333 164.704 103.291 164.704 98.305Z",
    fill: "#6989F6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M202.932 93.8767H188.463C187.664 93.8767 187.017 94.5245 187.017 95.3235C187.017 96.1226 187.664 96.7703 188.463 96.7703H202.932C203.731 96.7703 204.378 96.1226 204.378 95.3235C204.378 94.5245 203.731 93.8767 202.932 93.8767Z",
    fill: "#1A9FBD",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.847 99.8398H188.463C187.664 99.8398 187.017 100.488 187.017 101.287C187.017 102.086 187.664 102.733 188.463 102.733H218.847C219.646 102.733 220.293 102.086 220.293 101.287C220.293 100.488 219.646 99.8398 218.847 99.8398Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_bdddii_664_31722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 41.8447,
    width: 92.0431,
    height: 29.7943,
    rx: 6.01876,
    fill: "url(#paint9_linear_664_31722)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dd_664_31722)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.0127,
    y: 47.7134,
    width: 18.0563,
    height: 18.0563,
    rx: 9.02814,
    fill: "#4F78FE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_664_31722)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_664_31722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6887 54.877C37.6887 54.6952 37.5414 54.5479 37.3596 54.5479C37.1778 54.5479 37.0304 54.6952 37.0304 54.877C37.0304 55.9416 36.7952 56.633 36.3645 57.0637C35.9338 57.4945 35.2424 57.7296 34.1778 57.7296C33.996 57.7296 33.8486 57.877 33.8486 58.0588C33.8486 58.2406 33.996 58.3879 34.1778 58.3879C35.2424 58.3879 35.9338 58.6231 36.3645 59.0538C36.7952 59.4846 37.0304 60.176 37.0304 61.2406C37.0304 61.4224 37.1778 61.5698 37.3596 61.5698C37.5414 61.5698 37.6887 61.4224 37.6887 61.2406C37.6887 60.176 37.9239 59.4846 38.3546 59.0538C38.7854 58.6231 39.4768 58.3879 40.5413 58.3879C40.7232 58.3879 40.8705 58.2406 40.8705 58.0588C40.8705 57.877 40.7232 57.7296 40.5413 57.7296C39.4768 57.7296 38.7854 57.4945 38.3546 57.0637C37.9239 56.633 37.6887 55.9416 37.6887 54.877Z",
    fill: "url(#paint10_linear_664_31722)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9585 52.2435C33.9585 52.0617 33.8111 51.9143 33.6294 51.9143C33.4476 51.9143 33.3002 52.0617 33.3002 52.2435C33.3002 52.9271 33.1488 53.3442 32.8972 53.5959C32.6455 53.8476 32.2284 53.9989 31.5447 53.9989C31.3629 53.9989 31.2156 54.1463 31.2156 54.3281C31.2156 54.5099 31.3629 54.6572 31.5447 54.6572C32.2284 54.6572 32.6455 54.8086 32.8972 55.0603C33.1488 55.3119 33.3002 55.7291 33.3002 56.4127C33.3002 56.5945 33.4476 56.7419 33.6294 56.7419C33.8111 56.7419 33.9585 56.5945 33.9585 56.4127C33.9585 55.7291 34.1099 55.3119 34.3615 55.0603C34.6132 54.8086 35.0303 54.6572 35.714 54.6572C35.8958 54.6572 36.0431 54.5099 36.0431 54.3281C36.0431 54.1463 35.8958 53.9989 35.714 53.9989C35.0303 53.9989 34.6132 53.8476 34.3615 53.5959C34.1099 53.3442 33.9585 52.9271 33.9585 52.2435Z",
    fill: "url(#paint11_linear_664_31722)"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M65.2402 52.3132H50.772C49.973 52.3132 49.3252 52.961 49.3252 53.76C49.3252 54.5591 49.973 55.2069 50.772 55.2069H65.2402C66.0392 55.2069 66.687 54.5591 66.687 53.76C66.687 52.961 66.0392 52.3132 65.2402 52.3132Z",
    fill: "#393CFF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1552 58.2764H50.772C49.973 58.2764 49.3252 58.9241 49.3252 59.7232C49.3252 60.5222 49.973 61.17 50.772 61.17H81.1552C81.9542 61.17 82.602 60.5222 82.602 59.7232C82.602 58.9241 81.9542 58.2764 81.1552 58.2764Z",
    fill: "#0E0948",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdddii_664_31722",
    x: 44.0547,
    y: 33.2856,
    width: 87.6636,
    height: 87.6636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.65265
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.84424
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.76636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_31722",
    result: "effect2_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.73053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.73053
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_31722",
    result: "effect3_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.73053,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_31722",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_31722",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.19159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.09579
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.38318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.182632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_31722",
    result: "effect6_innerShadow_664_31722"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bdddii_664_31722",
    x: 140.485,
    y: 33.2856,
    width: 87.6636,
    height: 87.6636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.65265
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.84424
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.76636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_31722",
    result: "effect2_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.73053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.73053
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_31722",
    result: "effect3_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.73053,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_31722",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_31722",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.19159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.09579
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.38318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.182632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_31722",
    result: "effect6_innerShadow_664_31722"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdddii_664_31722",
    x: 61.5874,
    y: 14.2915,
    width: 149.028,
    height: 125.651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.65265
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.84424
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.76636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_31722",
    result: "effect2_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.73053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.73053
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_31722",
    result: "effect3_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.73053,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_31722",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_31722",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.19159
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.09579
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.38318
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.182632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_31722",
    result: "effect6_innerShadow_664_31722"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_664_31722",
    x: 125.874,
    y: 61.7758,
    width: 20.4548,
    height: 20.4548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.73053,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.73053
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.73053
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_31722",
    result: "effect2_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_31722",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bdddii_664_31722",
    x: 138.135,
    y: 71.3707,
    width: 128.156,
    height: 65.9067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.76172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.01876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.02814
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_31722",
    result: "effect2_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.752345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752345
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_31722",
    result: "effect3_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.752345,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_31722",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_31722",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.25703
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12852
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.51407
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.188086
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_31722",
    result: "effect6_innerShadow_664_31722"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_664_31722",
    x: 162.139,
    y: 87.9944,
    width: 23.1861,
    height: 23.1863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.28248,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.28248
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.28248
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_31722",
    result: "effect2_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_31722",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_bdddii_664_31722",
    x: 0.443724,
    y: 29.8072,
    width: 128.156,
    height: 65.9067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.76172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.01876
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.02814
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_664_31722",
    result: "effect2_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.752345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752345
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_664_31722",
    result: "effect3_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.752345,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_664_31722",
    result: "effect4_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_664_31722",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.25703
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.12852
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.423529 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect5_innerShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.51407
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.188086
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0745098 0 0 0 0 0.152941 0 0 0 0 0.427451 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_innerShadow_664_31722",
    result: "effect6_innerShadow_664_31722"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_664_31722",
    x: 25.508,
    y: 46.961,
    width: 21.0658,
    height: 21.0658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.752345,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.752345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.752345
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.054902 0 0 0 0 0.0352941 0 0 0 0 0.282353 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_664_31722",
    result: "effect2_dropShadow_664_31722"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_664_31722",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_664_31722",
    x1: 87.8865,
    y1: 44.9741,
    x2: 87.8865,
    y2: 97.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#597FFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C63E4",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_664_31722",
    x1: 184.317,
    y1: 44.9741,
    x2: 184.317,
    y2: 97.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#597FFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C63E4",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_664_31722",
    x1: 136.101,
    y1: 25.98,
    x2: 136.101,
    y2: 116.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A63EC",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#355AD5",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_664_31722",
    x1: 79.1201,
    y1: 71.2728,
    x2: 193.083,
    y2: 71.2728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4943,
    stopColor: "#375CD9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4944,
    stopColor: "#2F53CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#284ECD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_664_31722",
    x1: 136.102,
    y1: 31.0923,
    x2: 136.102,
    y2: 68.3493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B76E1",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B71E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_664_31722",
    x1: 136.102,
    y1: 87.3435,
    x2: 136.102,
    y2: 110.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B71E1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B78E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_664_31722",
    x1: 136.103,
    y1: 66.5838,
    x2: 138.295,
    y2: 77.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_664_31722",
    x1: 136.103,
    y1: 66.5837,
    x2: 138.295,
    y2: 77.8461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2748B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_664_31722",
    x1: 202.213,
    y1: 83.4082,
    x2: 202.213,
    y2: 113.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#597FFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C63E4",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_664_31722",
    x1: 64.5216,
    y1: 41.8447,
    x2: 64.5216,
    y2: 71.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#597FFF",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C63E4",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_664_31722",
    x1: 36.043,
    y1: 51.9146,
    x2: 38.2999,
    y2: 63.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AECAF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_664_31722",
    x1: 36.0431,
    y1: 51.9143,
    x2: 38.3,
    y2: 63.5129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2748B7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181.171,
    height: 124.19,
    fill: "white",
    transform: "translate(45.5159 33.2861)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.1201,
    y: 25.98,
    width: 113.963,
    height: 90.5857,
    rx: 5.84424,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5623,
    height: 73.053,
    fill: "white",
    transform: "translate(85.3296 34.7458)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5623,
    height: 73.053,
    fill: "white",
    transform: "translate(85.3296 34.7461)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5623,
    height: 73.053,
    fill: "white",
    transform: "translate(85.3296 34.7463)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.4844,
    height: 48.215,
    fill: "white",
    transform: "translate(140.85 33.2852)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.4844,
    height: 48.215,
    fill: "white",
    transform: "translate(140.85 33.2856)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.4844,
    height: 48.215,
    fill: "white",
    transform: "translate(140.85 33.2861)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9579,
    height: 10.2274,
    fill: "white",
    transform: "translate(130.623 66.1582)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9579,
    height: 10.2274,
    fill: "white",
    transform: "translate(130.623 66.158)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.9579,
    height: 10.2274,
    fill: "white",
    transform: "translate(130.623 66.1577)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2852,
    height: 10.5328,
    fill: "white",
    transform: "translate(30.3984 51.4753)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2852,
    height: 10.5328,
    fill: "white",
    transform: "translate(30.3984 51.4756)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_664_31722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2852,
    height: 10.5328,
    fill: "white",
    transform: "translate(30.3984 51.4758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.08df20c1ea4547ce1a29a8818d67fdec.svg";
export { ForwardRef as ReactComponent };